
    
  // ...existing code...
import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalServiceService } from '../Services/GlobalService/global-service.service';
import { Http } from '@angular/http';
import { LocalStorageService } from 'angular-2-local-storage';
import { Constant } from 'src/Constant';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
interface MonthObject {
  month: number;
}
@Component({
  selector: 'app-mandate-home',
  templateUrl: './mandate-home.component.html',
  styleUrls: ['./mandate-home.component.css'],
})
export class MandateHomeComponent implements OnInit {
  @ViewChild('ccsinewcustbtn') ccsinewcustbtn!: ElementRef;
  @ViewChild('ccsiextcustbtn') ccsiextcustbtn!: ElementRef;

  @ViewChild('netbankemandatenewcust') netbankemandatenewcust!: ElementRef;
  @ViewChild('netbankemandateextcust') netbankemandateextcust!: ElementRef;
  @ViewChild('netbankemandateextcust_ngin')
  netbankemandateextcust_ngin!: ElementRef;

  @ViewChild('netbankenachnewcust') netbankenachnewcust!: ElementRef;
  @ViewChild('netbankenachextcust') netbankenachextcust!: ElementRef;
  @ViewChild('netbankenachnewcust_ngin') netbankenachnewcust_ngin!: ElementRef;
  @ViewChild('netbankenachextcust_ngin') netbankenachextcust_ngin!: ElementRef;

  @ViewChild('upinewcust') upinewcust!: ElementRef;
  @ViewChild('upiextcust') upiextcust!: ElementRef;
  @ViewChild('upiextcust_ngin') upiextcust_ngin!: ElementRef;

  @ViewChild('upiinstabcust') upiinstabcust!: ElementRef;
  @ViewChild('templet2') templet2!: ElementRef;
  @ViewChild('instabmodal') instabmodal!: ElementRef;

  @ViewChild('collapseOne') collapseOne!: ElementRef;
  @ViewChild('collapseTwo') collapseTwo!: ElementRef;
  @ViewChild('collapseThree') collapseThree!: ElementRef;
  @ViewChild('closeaccordian1') closeaccordian1!: ElementRef;

  public autopolicyno: any;
  public autodob: any;
  public paymentType: any;
  public originalPremiumAmt!: 0;
  public isValidAppno = false;
  public isValidPolicyno = false;
  public isValidNGINPolicyno = false;

  public isValidAge = false;
  //public isValidYear = false;
  public isstatus: any = '';
  public finalDate: any;
  public Amount: any;
  public appl: any;
  public isError = false;
  public isErrorNewForm = false;
  public errorMessage: any;

  // public showNewForm: boolean = false;
  // public showOldForm: boolean = false;

  // public showPolicyN: boolean = false;
  // public showPolicyO: boolean = false;

  // public showDateO: boolean = false;
  // public showDateN: boolean = false;

  // public showAmtN: boolean = false;
  // public showAmtO: boolean = false

  // public showFreN: boolean = false;
  // public showFreO: boolean = false;

  public newCustDate: any;
  modalRef!: BsModalRef;
  modalRef1!: BsModalRef;
  modalRef2!: BsModalRef;
  modalRef3!: BsModalRef;

  type: any;
  public userDatanewCustomer: any;
  public userDataexistingCustomer: any;
  public bsConfig: any;
  public bsConfig1: any;
  public temp: any;

  templateRef: any;
  isLimitCross: boolean = false;
  isExistingCustomer: boolean = false;
  hideExistingCustForm: boolean = false;
  nbComboSolnID: any;
  isInHouseApplNo: boolean = false;
  retryPolicy: any;
  enableForUPIVendor: any;

  public validateForm!: FormGroup;
  public userdata: any;
  public dataProvided: any;
  public dummydata: any;
  public instabFormData: any;
  //public isInstab: boolean = false;
  public accountDetails: any;
  getAccountNo!: string;
  getIFSCNo!: string;
  selectedPaymentOption: string = 'debitNetbankingeNach';
  selectedRadioOption: string = 'yes';
  isChecked: boolean = false;
  uniqueId: any;
  showAccodian1: boolean = false;
  showAccodian2: boolean = false;
  showAccodian3: boolean = false;

  public isPolicy: any = '';
  public fromInstab: any = '';

  ccsiPayglocal: any;
  frequencyforccsiNRIExisting: any;
  frequencyforccsiNRINew: any;
  datePipe: DatePipe = new DatePipe('en-US');
  showCCSINRI = false;
  nriFLAG: any = '';

  public preferedDateList: MonthObject[] = [];
  public mandateVal: any;
  public isShow: boolean = false;
  public userDateDetails = {
    dateType: '',
    isDisabled: '',
    selectedPDate: '',
    registerAccount: 'N',
  };
  subModule: any;
  isallowed = 'Y';
  emandate: any;
  ccsi: any;
  enach: any;
  upiManUrl: any;
  showEnach: boolean = true;
  showCCSIPan = true;
  showUPIPan = false;
  showEnachPan = false;
  showEmandatePan = false;
  frequency: any;
  duedate: any;
  isthroughCustPortal: boolean = false;
  showPrefillOption: boolean = false;
  r_registerType: any = '';
  downTimeData: any = [];
  desableForDwontime: boolean = false;
  isChannel: any;
  isApplnChannel: any;
  encryptValue: any;
  enableForVendor: any;
  agentCode: any;
  activateUPIForNB: any;
  moduleFlag: boolean = false;
  // mandateValueForUpi: any;
  activateUPI: boolean = false;

  isDOBRequired = true;
  applicationOrPolicynoMaxLength = 10;
  days: number[] = Array(31)
    .fill(0)
    .map((x, i) => i + 1);
  ccsiReturnUrl!: string;
  displayNum: any;
  enableForCCSIVendor: any;
  // mandateAmountNewCustomer: any;
  premiumWithGST: any;

  isDefenceAppln: boolean = false; // OPS-7166

  blockUPI: boolean = false;

  payment_details_list = [
    {
      policy_no: '',
      policy_holder_name: '',
      from_due_date: '',
      premium_installment: '',
      total_amount: '',
      gst_st: '',
      frequency: '',
      commencement_date: '',
      dob: '',
      email_id: '',
      mobile_no: '',
      final_amount: '',
      start_date: '',
      end_date: '',
      sequence_no: '',
      moduleName: '',
    },
  ];

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private service: GlobalServiceService,
    private localStorageService: LocalStorageService,
    private toster: ToastrService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private http: Http,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.showAccodian1 = true;
    this.localStorageService.clearAll();
    this.dummydata = '';
    this.manadateAuthToken();
    this.dataProvided = {
      applicationOrPolicyno: '',
      dateOfBirth: '',
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.channel != '' && params.channel == 'agency') {
        this.localStorageService.set('channel', params.channel);
        this.getUniqueId();
      }
    });

    this.subModule = sessionStorage.getItem('p_si_sub_module');
    this.autopolicyno = sessionStorage.getItem('p_policy_no_auto');
    this.autodob = sessionStorage.getItem('p_dob_auto');
    this.paymentType = sessionStorage.getItem('p_mandate_type');

    if (this.activatedRoute.snapshot.queryParams['retry_policy']) {
      this.retryPolicy =
        this.activatedRoute.snapshot.queryParams['retry_policy'];
      if (this.retryPolicy)
        this.getRetryDataforExistingCustomer(this.retryPolicy);
    }
    if (this.activatedRoute.snapshot.queryParams['retry_unique_code']) {
      let uniqueCode =
        this.activatedRoute.snapshot.queryParams['retry_unique_code'];
      if (uniqueCode) this.getUniqueId();
    }

    this.userDataexistingCustomer = {
      policyNumber: '',
      dateOfBirth: '',
      ischeckexis: '',
    };

    this.userDatanewCustomer = {
      applicationNo: '',
      dateOfBirth: '',
      premiumAmount: '',
      frequency: '',
      ischecked: '',
    };

    if (
      this.activatedRoute.snapshot.queryParams['appl_no'] &&
      this.activatedRoute.snapshot.queryParams['flag'] == 'shortJourney'
    ) {
      this.checkForShortenedJourney();
    } else if (
      this.activatedRoute.snapshot.queryParams['appl_no'] &&
      this.activatedRoute.snapshot.queryParams['flag'] == 'sachetJourney'
    ) {
      this.checkForSachetJourney();
    } else if (this.activatedRoute.snapshot.queryParams['appl_no']) {
      this.checkforgeneric();
    } else if (this.autopolicyno && this.autodob) {
      this.isExistingCustomer = true;
      this.userDataexistingCustomer.policyNumber = this.autopolicyno;
      this.userDataexistingCustomer.dateOfBirth = this.autodob;
      this.spinner.show();
      this.submitAlredyExistingCustomersData();
    } else if (
      this.activatedRoute.snapshot.queryParams['autopay_mandate_type']
    ) {
      let type =
        this.activatedRoute.snapshot.queryParams['autopay_mandate_type'];
      if (type === 'CCSI' || type === 'ccsi') {
        // this.showNewForm = false;
        // this.showOldForm = false;
        // this.type = type;
        // alert("CCSI facility is not available. Request to you please select another renewal preferred mode.");
      } else {
        this.paymentType =
          this.activatedRoute.snapshot.queryParams['autopay_mandate_type'];
        //  this.showNewForm = false;
        //var acc = document.getElementById('clickontwo')!.click();
        //  $('#paneltwo').css('max-height', '1500px');
      }
    } else if (this.activatedRoute.snapshot.queryParams['sub_module']) {
      let key = this.activatedRoute.snapshot.queryParams['sub_module'];
      this.isstatus = 'existingCustomer';
      this.getRespectiveData(key);
    }

    this.instabFormData = {
      PolicyHolderModal: '',
      dateIDModal: '',
      PremiumValueInclusive: '',
      FrequencyModal: 'Monthly',
      MandateValueModal: '',
    };
  }

  //get unique  id for INSTAB user
  getUniqueId() {
    let url = Constant.BaseUrl + Constant.getUniqueAppid;
    let reqObj = {
      p_application: 'OPEN_LINK',
    };
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      if (response.p_error_code === 'SUCCESS') {
        //  this.localStorageService.set('isInstab', true);
        //this.localStorageService.set('uniqueid', response.p_unique_id);
        this.uniqueId = response.p_unique_id;
        //this.router.navigate(['/instabuser']);
      } else {
        alert(response.p_message);
      }
      setTimeout(() => {
        /** spinner ends after 3 seconds */
        this.spinner.hide();
      }, 3000);
    });
  }

  //check for NB generic ( if yes route to genericlick component)
  checkforgeneric() {
    let id = this.activatedRoute.snapshot.queryParams['appl_no'];
    let payMode = this.activatedRoute.snapshot.queryParams['pay_mode'];

    let dualMandateFlag = this.activatedRoute.snapshot.queryParams['dualMandateFlag'];
    let dualMandateType = this.activatedRoute.snapshot.queryParams['dualMandateType'];
    let callbackURL = this.activatedRoute.snapshot.queryParams['callbackURL'];

    this.localStorageService.set('p_policy_no_auto', id);
    this.localStorageService.set('ren_pay_mode', payMode);

    this.localStorageService.set("dualMandateFlag", dualMandateFlag);
    this.localStorageService.set("dualMandateType", dualMandateType);

    this.localStorageService.set("callbackURL", callbackURL);

    this.router.navigate(['/genericLink']);
  }

  checkForShortenedJourney() {
    let id = this.activatedRoute.snapshot.queryParams['appl_no'];
    let callbackURL = this.activatedRoute.snapshot.queryParams['callbackURL'];
    let flag = this.activatedRoute.snapshot.queryParams['flag'];
    let transId = this.activatedRoute.snapshot.queryParams['transId'];
    let channel = this.activatedRoute.snapshot.queryParams['channel'];
    let frequency = this.activatedRoute.snapshot.queryParams['frequency'];
    let source = this.activatedRoute.snapshot.queryParams['source'];

    this.localStorageService.set('p_policy_no_auto', id);
    this.localStorageService.set('callbackURL', callbackURL);
    this.localStorageService.set('flag', flag);
    this.localStorageService.set('transId', transId);
    this.localStorageService.set('channel', channel);
    this.localStorageService.set('frequency', frequency);
    this.localStorageService.set('source', source);

    this.router.navigate(['/ShortendJourney']);
  }

  checkForSachetJourney() {
    let id = this.activatedRoute.snapshot.queryParams['appl_no'];
    let payMode = this.activatedRoute.snapshot.queryParams['pay_mode'];
    let callbackURL = this.activatedRoute.snapshot.queryParams['callbackURL'];
    let flag = this.activatedRoute.snapshot.queryParams['flag'];

    this.localStorageService.set('p_policy_no_auto', id);
    this.localStorageService.set('ren_pay_mode', payMode);
    this.localStorageService.set('callbackURL', callbackURL);
    this.localStorageService.set('flag', flag);

    this.router.navigate(['/SachetJourney']);
  }

  submitAlredyExistingCustomersData() {
    // this.localStorageService.set("issentered", '123'); // for whatsup user.
    this.spinner.show();
    this.isError = false;
    // this.localStorageService.set('Status', 'existingCustomer');
    this.isstatus = 'existingCustomer';
    let url = Constant.BaseUrl + Constant.setNewCustomerData;
    let reqObj = {
      p_application_no: this.userDataexistingCustomer.policyNumber,
      p_dob: this.userDataexistingCustomer.dateOfBirth,
      p_prem_amount: '',
      p_frequency_value: '',
      p_module: 'OPEN_LINK_EXISTING',
      p_is_unique_code: 'NO',
    };
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        if (response.p_error_code === 'SUCCESS') {
          //for dynamic link
          // this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
          this.nriFLAG = response.p_data.stringval11;
          this.localStorageService.set(
            'setPSFFlag',
            response.p_data.stringval12
          );
          this.localStorageService.set(
            'setGBOFlag',
            response.p_data.stringval13
          );
          this.displayNum = this.userDataexistingCustomer.policyNumber;
          this.getAllDataforExistingCustomer();
        } else if (
          response.p_error_code === 'ERROR' ||
          response.p_error_code !== 'SUCCESS'
        ) {
          // this.showNewForm = false;
          // this.showOldForm = false;
          this.errorMessage = response.p_message;
          this.toster.error(response.p_message);
          this.spinner.hide();
        }
      },
      (error) => {
        this.errorMessage =
          'Oops! Something went wrong. Please try again later.';
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    );
  }

  getRespectiveData(key: any) {
    console.log('key is', key);
    this.spinner.show();
    let group_id;
    this.activatedRoute.queryParams.subscribe((params) => {
      group_id = params['group_id'];
    });
    if (key == 'group_mandate') {
      let url = Constant.BaseUrl + Constant.getPolicyDtlsOnGroupid;
      let reqObj = {
        group_id: group_id,
        request_source: 'MR',
      };
      this.service.PostService(url, reqObj).subscribe((response: any) => {
        if (response.status === 'SUCCESS' || response.status === 'success') {
          let data = response;
          this.payment_details_list.forEach((el) => {
            el.policy_holder_name = data.policy_holder_name;
            el.policy_no = data.group_id;
            el.start_date = data.start_date;
            el.end_date = data.end_date;
            el.from_due_date = data.next_due_date;
            el.mobile_no = data.consumer_mobile_no;
            el.email_id = data.consumer_email_id;
            el.frequency = data.frequency;
            el.final_amount = data.max_amount;
            el.premium_installment = data.premium_amount;
            el.gst_st = data.gst_amount;
            el.moduleName = 'GROUP_ID';
          });
          // this.localStorageService.set("userdata",this.payment_details_list);
          // this.localStorageService.set("Status",this.isstatus);
          this.localStorageService.set('customerportal', 'all');
          // this.router.navigate(['/Customer']);

          this.userdata = this.payment_details_list;
          this.displayNum = this.payment_details_list[0].policy_no;
          this.getPaymentData();

          this.showAccodian2 = true;
          this.showAccodian3 = true;

          setTimeout(() => {
            if (this.collapseTwo && this.collapseTwo.nativeElement) {
              this.collapseTwo.nativeElement.classList.add('show');
            }
            if (this.collapseThree && this.collapseThree.nativeElement) {
              this.collapseThree.nativeElement.classList.add('show');
            }
            if (this.closeaccordian1 && this.closeaccordian1.nativeElement) {
              this.closeaccordian1.nativeElement.click();
            }
          });

          setTimeout(() => {
            this.spinner.hide();
          }, 3000);
        } else {
          let error = response.errorMsg
            ? response.errorMsg
            : 'Something Went Wrong Please try again later!';
          this.toster.error(error);
        }
        setTimeout(() => {
          /** spinner ends after 3 seconds */
          this.spinner.hide();
        }, 3000);
      });
    } else if (key == 'frequency_change') {
      //debugger
      this.activatedRoute.queryParams.subscribe((params) => {
        this.payment_details_list[0].policy_holder_name =
          params['policyHolderName'];
        this.payment_details_list[0].policy_no = params['consumerId'];
        this.payment_details_list[0].start_date = params['debitStartDate'];
        this.payment_details_list[0].end_date = params['debitEndDate'];
        this.payment_details_list[0].from_due_date = params['debitStartDate'];
        this.payment_details_list[0].frequency = params['new_frequency'];
        this.payment_details_list[0].mobile_no = params['consumerMobileNo'];
        this.payment_details_list[0].email_id = params['consumerEmailId'];
        this.payment_details_list[0].premium_installment =
          params['new_modal_premium'];
        this.payment_details_list[0].gst_st = params['gst_amount'];
        this.payment_details_list[0].moduleName = key;
        // let maxAmout = (parseInt(this.payment_details_list[0].premium_installment) +  parseInt(this.payment_details_list[0].gst_st) * 1.1);
        // this.payment_details_list[0].final_amount = maxAmout.toString() ! === 'NAN' ? maxAmout.toString() : "0";
        let maxAmout =
          parseInt(this.payment_details_list[0].premium_installment) > 0
            ? parseInt(this.payment_details_list[0].premium_installment) +
              parseInt(this.payment_details_list[0].gst_st) * 1.1
            : '0';
        this.payment_details_list[0].final_amount = maxAmout
          ? maxAmout.toString()
          : '0';
      });
      if (this.payment_details_list[0].policy_no) {
        // this.localStorageService.set("userdata",this.payment_details_list);
        // this.localStorageService.set("Status",this.isstatus);
        this.localStorageService.set('customerportal', 'all');
        // this.router.navigate(['/Customer']);

        this.userdata = this.payment_details_list;
        this.displayNum = this.payment_details_list[0].policy_no;
        this.getPaymentData();

        this.showAccodian2 = true;
        this.showAccodian3 = true;

        setTimeout(() => {
          if (this.collapseTwo && this.collapseTwo.nativeElement) {
            this.collapseTwo.nativeElement.classList.add('show');
          }
          if (this.collapseThree && this.collapseThree.nativeElement) {
            this.collapseThree.nativeElement.classList.add('show');
          }
          if (this.closeaccordian1 && this.closeaccordian1.nativeElement) {
            this.closeaccordian1.nativeElement.click();
          }
        });

        setTimeout(() => {
          this.spinner.hide();
        }, 3000);
      } else {
        this.toster.error(
          'Oops! Something went wrong. Please try again later.'
        );
      }
    }
  }

  getAllDataforExistingCustomer() {
    // for whatsup user
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj =
    {
      "policy_no": this.userDataexistingCustomer.policyNumber,
      "dob": this.userDataexistingCustomer.dateOfBirth,
      "mobile_no": "",
      "email_id": "",
      "request_source": "AUTO_PAY",
      "is_insured": "Y"
    }
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      let data = [];
      if (response.status === 'success' || response.p_error_code === 'SUCCESS') {
        data = response.payment_details_list;
        if (data) {
          this.userdata = response.payment_details_list;

          //PD-1839 - if multiple policies are present for existing customer then filter based on policy no
             if (response.payment_details_list.length > 1) {
              this.userdata = response.payment_details_list.filter(
                (item: any) => item.policy_no === reqObj.policy_no
              );
            }

          this.isstatus = 'existingCustomer';
          this.isPolicy = 'NGIN' // setting NGIN because  of dynamic method

            if (this.userdata[0].is_opus_policy == 'Y') {
              this.isPolicy = 'OPUS';
            }

            this.getPaymentData();
            this.showAccodian2 = true;
            this.showAccodian3 = true;

            this.collapseTwo.nativeElement.classList.add('show');
            this.collapseThree.nativeElement.classList.add('show');

            if (this.closeaccordian1) {
              this.closeaccordian1.nativeElement.click();
            }

            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.spinner.hide();
            this.toster.error(
              'Oops! Something went wrong. Please try again later.'
            );
          }
        } else {
          // this.isError = true;
          // this.showNewForm = false;
          // this.showOldForm = false;
          this.errorMessage = response.p_message;
          this.toster.error(this.errorMessage);
          this.spinner.hide();
        }
      },
      (error) => {
        this.errorMessage =
          'Oops! Something went wrong. Please try again later.';
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    );
  }

  getRetryDataforExistingCustomer(policy_no: any) {
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj = {
      p_policy_no: policy_no,
      p_dob: '',
      p_email_id: '',
      p_mobile_no: '',
      p_application: 'AUTO_PAY',
    };
    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        let data = [];
        if (response.p_error_code === 'SUCCESS') {
          data = response.p_pymnt_list;
          if (data) {
            this.userdata = response.p_pymnt_list;
            this.isstatus = 'existingCustomer';
            this.displayNum = policy_no;
            this.getPaymentData();
            this.showAccodian2 = true;
            this.showAccodian3 = true;
            this.collapseTwo.nativeElement.classList.add('show');
            this.collapseThree.nativeElement.classList.add('show');

            if (this.closeaccordian1) {
              this.closeaccordian1.nativeElement.click();
            }

            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.spinner.hide();
            this.toster.error(
              'Oops! Something went wrong. Please try again later.'
            );
          }
        } else {
          //this.isError = true;
          // this.showNewForm = false;
          // this.showOldForm = false;
          this.errorMessage = response.p_message;
          this.toster.error(this.errorMessage);
          this.spinner.hide();
        }
      },
      (error) => {
        this.errorMessage =
          'Oops! Something went wrong. Please try again later.';
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    );
  }

  checkAppNoPattern(value1: any) {
    const value = value1.target.value;
    let val = '';
    if (value.startsWith('0') || value.startsWith('1')) {
      // this.isDOBRequired = true;
      if (value.startsWith('1')) {
        val = 'NGIN';
        this.applicationOrPolicynoMaxLength = 11;
      } else {
        val = 'OPUS';
        this.applicationOrPolicynoMaxLength = 10;
      }
      this.checkPolicyno(value1, val);
      console.log('existing customer');
    } else {
      // this.isDOBRequired = false;
      this.checkApplicationno(value1);
      console.log('new customer');
    }
  }

  checkPolicyno(event: any, flag: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    } else {
      if (flag == 'NGIN') {
        if (
          this.dataProvided.applicationOrPolicyno.length !== 11 &&
          this.dataProvided.applicationOrPolicyno.length !== 0
        ) {
          this.isValidNGINPolicyno = true;
        } else if (
          this.dataProvided.applicationOrPolicyno.length == 11 ||
          this.dataProvided.applicationOrPolicyno.length == 0
        ) {
          this.isValidNGINPolicyno = false;
        }
      }
      if (flag == 'OPUS') {
        if (
          this.dataProvided.applicationOrPolicyno.length !== 10 &&
          this.dataProvided.applicationOrPolicyno.length !== 0
        ) {
          this.isValidPolicyno = true;
        } else if (
          this.dataProvided.applicationOrPolicyno.length == 10 ||
          this.dataProvided.applicationOrPolicyno.length == 0
        ) {
          this.isValidPolicyno = false;
        }
      }
    }
  }

  checkApplicationno(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
    } else {
      if (
        this.dataProvided.applicationOrPolicyno.length !== 10 &&
        this.dataProvided.applicationOrPolicyno.length !== 0
      ) {
        this.isValidAppno = true;
      } else if (
        this.dataProvided.applicationOrPolicyno.length == 10 ||
        this.dataProvided.applicationOrPolicyno.length == 0
      ) {
        this.isValidAppno = false;
      }
    }
  }

  checkPremiumValueInclusive(event: any) {
    const pattern = /^([0-9]+\.?[0-9]*)?$/; // updated pattern to restrict decimal point
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9\.]/g, ''); // updated replacement pattern
    }
  }

  decline(): void {
    this.localStorageService.remove('userdata');
    this.modalRef1.hide();
  }

  closethePopup() {
    this.isErrorNewForm = false;
    this.isError = false;
  }

  confirm(): void {
    this.modalRef1.hide();
    this.spinner.show();
    this.router.navigate(['/Customer']);
    this.spinner.hide();
  }

  submitFormData(
    template: any,
    template1: any,
    template2: any,
    template3: any
  ) {
    this.showPrefillOption = false;
    this.showAccodian2 = false;
    this.showAccodian3 = false;
    this.showCCSINRI = false;
    this.showUPIPan = false;
    this.fromInstab = 'False';
    this.localStorageService.clearAll();

    if (
      !this.dataProvided.applicationOrPolicyno.startsWith('0') &&
      !this.dataProvided.applicationOrPolicyno.startsWith('1')
    ) {
      this.isstatus = 'newCustomer';
    } else if (
      (this.dataProvided.applicationOrPolicyno.startsWith('0') ||
        this.dataProvided.applicationOrPolicyno.startsWith('1')) &&
      this.dataProvided.dateOfBirth
    ) {
      this.isstatus = 'existingCustomer';
    }
    this.displayNum = this.dataProvided.applicationOrPolicyno;
    if (this.isstatus == 'newCustomer') {
      this.userdata = null;
      this.checkPolicy(
        this.dataProvided.applicationOrPolicyno,
        this.dataProvided.dateOfBirth,
        template,
        template2,
        template3
      );
    } else if (this.isstatus == 'existingCustomer') {
      this.userdata = null;
      this.submitexistingCustomerData(template, template1);
    }
  }
  newAgentCode: any
  mandateTokenValue: any;
  manadateAuthToken(){
    const authCred = Constant.authCred;
    let url = Constant.mandateAuthToken;
     this.service.PostService(url, authCred).subscribe((response: any) => {
          console.log(response);
          this.mandateTokenValue = response.token
        },(error)=>{
          console.log(error);
        });
  }
  channel: any
  subChannel: any
  channelDetails(code: any, token :any){
    let url = Constant.channelDetails(code);
     this.service.getService(url, token).subscribe((response: any) => {
          this.channel = response.channel
          this.subChannel = response.subChannel
        },(error)=>{
          console.log(error);
        });
  }

  nginFlag!: string;
  date: any;
  newdate2: any;
  newdate3: any;
  premium: any;
  freq: any;
  frequencyShow: any;
  routingInfoList: any = [];
  checkPolicy(
    event: any,
    dob: any,
    template: any,
    template2: any,
    template3: any
  ) {
    this.isDefenceAppln = false; // OPS-7166

    this.appl = event;
    let url = Constant.BaseUrl + Constant.getFetchAutoData;
    let urlCheckPolicy = Constant.BaseUrl + Constant.checkPolicy;
    let reqObj = {
      p_application_no: this.appl,
      p_application: '',
    };
    let reqObj1 = {
      appln_number: this.appl,
    };
    this.spinner.show();
    this.service
      .PostService(urlCheckPolicy, reqObj1)
      .subscribe((response: any) => {
        if (response.statusCode == '200') {
          this.routingInfoList = response.routingInfoList[0];
          this.nginFlag = this.routingInfoList.target_system;
          if (this.routingInfoList.target_system == 'N') {
            this.spinner.hide();
            this.isPolicy = 'NGIN';
            this.toster.success('Proceeding with NGIN');
            this.proceedToNgin(event, dob, template, template2, template3);
          } else {
            this.isPolicy = 'OPUS';
            // For OPUS policy
            this.service.PostService(url, reqObj).subscribe(
              (response: any) => {
                this.spinner.hide();
                if (
                  response.ques_list.length == 0 ||
                  (response.ques_list[0].stringval1 == '' &&
                    response.ques_list[0].stringval2 == '' &&
                    response.ques_list[0].stringval3 == '')
                ) {
                  this.modalRef3 = this.modalService.show(template3, {
                    class: 'modal-md addcompmodal',
                  });
                  this.premium = '';
                  this.newdate2 = '';
                  this.frequencyShow = '';
                }
                if (response.ques_list.length != 0) {
                  if (response.ques_list[0].stringval1 != '') {
                    this.premium = response.ques_list[0].stringval1;
                    // this.showAmtO = false;
                    // this.showAmtN = true;
                  }

                  if (response.ques_list[0].stringval10 != '') {
                    this.nriFLAG = response.ques_list[0].stringval10;
                  }

                  if (response.ques_list[0].stringval2 != '') {
                    this.date = response.ques_list[0].stringval2;
                    this.newdate2 = moment(this.date, 'MM-DD-YYYY').format(
                      'DD-MM-YYYY'
                    );
                    // this.showDateO = false;
                    // this.showDateN = true;
                  }

                  if (response.ques_list[0].stringval3 != '') {
                    this.freq = response.ques_list[0].stringval3;
                    // this.showFreO = false;
                    // this.showFreN = true;
                    if (this.freq == '1') {
                      this.frequencyShow = 'Yearly';
                    } else if (this.freq == '2') {
                      this.frequencyShow = 'Half-Yearly';
                    } else if (this.freq == '4') {
                      this.frequencyShow = 'Quarterly';
                    } else if (this.freq == '12') {
                      this.frequencyShow = 'Monthly';
                    }
                  }

                  if (response.ques_list[0].stringval4 != '') {
                    if (
                      response.ques_list[0].stringval4.toLowerCase() ==
                        'agency' ||
                      response.ques_list[0].stringval4.toLowerCase() == 'psf'
                    ) {
                      this.isApplnChannel =
                        response.ques_list[0].stringval4.toLowerCase();
                    } else if (
                      response.ques_list[0].stringval4.toLowerCase() ==
                      'psf_defence'
                    ) {
                      this.isApplnChannel =
                        response.ques_list[0].stringval4.toLowerCase();
                      this.isDefenceAppln = true;
                    }
                  }

                  if (response.ques_list[0].stringval5 != '') {
                    this.agentCode = response.ques_list[0].stringval5;
                  }

                  //for nb combo
                  if (response.ques_list[0].stringval6 != '') {
                    this.nbComboSolnID = response.ques_list[0].stringval6;
                  }
                  if (response.ques_list[0].stringval7 != '') {
                    if (
                      response.ques_list[0].stringval7 == 'IPPBBC' ||
                      response.ques_list[0].stringval7 == 'IPPB' ||
                      response.ques_list[0].stringval7 == 'IPPBC'
                    )
                      this.localStorageService.set(
                        'moduleFlag',
                        response.ques_list[0].stringval7
                      );
                  }

                  if (response.ques_list[0].stringval7 != '') {
                    if (response.ques_list[0].stringval7 == 'GBOWEB')
                      this.localStorageService.set(
                        'moduleFlag',
                        response.ques_list[0].stringval7
                      );
                  }

                  if (response.ques_list[0].stringval5 != '') {
                    response.ques_list[0].stringval5 == '3000000007'
                      ? (this.isInHouseApplNo = true)
                      : (this.isInHouseApplNo = false);
                    this.agentCode = response.ques_list[0].stringval5;
                    this.newAgentCode = response.ques_list[0].stringval5;
                  }

                  //validation of DOB
                  const apiDate = moment(
                    this.dataProvided.dateOfBirth,
                    'MM-DD-YYYY'
                  ).format('DD-MM-YYYY');
                  //   const apiDate2 = moment(this.newdate2, 'MM-DD-YYYY').format('DD-MM-YYYY');
                  const apiDate2 = this.newdate2;
                  // console.log("this.dataProvided.dateOfBirth" + this.dataProvided.dateOfBirth);
                  // console.log("this.newdate2"+this.newdate2);
                  // console.log("apiDate"+apiDate)
                  // console.log("apiDate2"+apiDate2)

                  if (apiDate2 === apiDate) {
                    console.log('Valid Date');
                  } else {
                    console.log('Non Valid Date');
                    this.dataProvided.dateOfBirth = '';
                    this.errorMessage = 'Invalid DOB';
                    this.toster.error(this.errorMessage);
                    return;
                  }

                  this.userDatanewCustomer = {
                    applicationNo: this.appl,
                    dateOfBirth: this.newdate2,
                    premiumAmount: this.premium,
                    frequency: this.frequencyShow,
                  };

                  if (
                    this.userDatanewCustomer.applicationNo != '' &&
                    this.userDatanewCustomer.dateOfBirth != '' &&
                    this.userDatanewCustomer.premiumAmount != '' &&
                    this.userDatanewCustomer.frequency != ''
                  ) {
                     let url = Constant.channelDetails(this.newAgentCode);
                      this.service.getService(url, this.mandateTokenValue).subscribe((response: any) => {

                        this.channel = response.channel
                        this.subChannel = response.subChannel
                        this.submitNewCustomerData(template);
                      }, (error) => {
                        console.log(error);
                        this.errorMessage =
                          'Oops! Something went wrong. Please try again later.';
                        this.toster.error(this.errorMessage);
                        this.spinner.hide();
                      });
                  }
                } else if (
                  response.p_error_code === 'ERROR' ||
                  response.p_error_code !== 'SUCCESS'
                ) {
                  this.errorMessage = response.p_message;
                  this.toster.error(response.p_message);
                }
              },
              (error) => {
                this.errorMessage =
                  'Oops! Something went wrong. Please try again later.';
                this.toster.error(this.errorMessage);
                this.spinner.hide();
              }
            );
          }
        } else {
          this.errorMessage =
            'Oops! Something went wrong. Please try again later.';
          this.toster.error(this.errorMessage);
          this.spinner.hide();
        }
      });
  }

  convertintoInt(value: any) {
    if (value) {
      return parseInt(value);
    } else {
      return 0;
    }
  }

  submitNewCustomerData(template: any) {
    if (this.isValidAppno || this.isValidAge) {
      this.toster.error('Please fill the required fields!');
      return;
    }
    this.isErrorNewForm = false;
    if (this.userDatanewCustomer.dateOfBirth.length != 10) {
      const date1 = moment(
        this.userDatanewCustomer.dateOfBirth,
        'MM-DD-YYYY'
      ).format('DD-MM-YYYY');
      this.userDatanewCustomer.dateOfBirth = date1;
    }

    if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (
      this.userDatanewCustomer.frequency.toString() === 'Half-Yearly'
    ) {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = this.isInHouseApplNo?(this.Amount * 1.25):(this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    }

    //OPS-24553
    if (this.isInHouseApplNo == true) {
      this.Amount = (this.Amount / 1.3) * 1.25;
    }

    if (this.isDefenceAppln) {
      if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
        this.Amount = (this.Amount / 1.3) * 6;
      } else {
        this.Amount = this.Amount * this.freq;
      }
    } // OPS-7166

    if (this.channel == 'PSF') {
      if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
        this.Amount = (this.Amount / 1.3) * 6;
      }else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
        this.Amount = this.Amount * 4;
      }
      else if (this.userDatanewCustomer.frequency.toString() === 'Half-Yearly') {
        this.Amount = this.Amount * 2;
      }
      else {
        this.Amount = this.Amount
      }
    } //OPS-27157

    let url = Constant.BaseUrl + Constant.setNewCustomerData;
    let reqObj = {
      p_application_no: this.nbComboSolnID
        ? this.nbComboSolnID
        : this.userDatanewCustomer.applicationNo,
      p_unique_id: '',
      p_dob: this.userDatanewCustomer.dateOfBirth,
      p_prem_amount: this.Amount.toFixed(2),
      p_frequency_value: this.userDatanewCustomer.frequency,
      p_module: 'OPEN_LINK_NEW',
      p_is_unique_code: 'NO',
    };
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        if (response.p_error_code === 'SUCCESS') {
          this.spinner.hide();

          this.userdata = response.p_data;
          this.originalPremiumAmt = this.userDatanewCustomer.premiumAmount;
          this.maskifyACno();
          //this.nriFLAG = response.p_data.stringval11;
          // this.mandateAmountNewCustomer = this.originalPremiumAmt * 1.50
          //  this.finalMandateAmount = parseFloat(this.userdata.stringval5).toFixed(2);

          this.getPaymentData();
          this.showAccodian2 = true;
          this.showAccodian3 = true;
          this.collapseTwo.nativeElement.classList.add('show');
          this.collapseThree.nativeElement.classList.add('show');
          if (this.closeaccordian1) {
            this.closeaccordian1.nativeElement.click();
          }
        } else {
          this.spinner.hide();
          this.modalRef = this.modalService.show(template, {
            class: 'modal-lg addcompmodal',
          });
          this.isErrorNewForm = true;
          this.errorMessage = response.p_message;
          this.userDataexistingCustomer.policyNumber = '';
          this.userDataexistingCustomer.dateOfBirth = '';
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  // for maskify AC no
  maskifyACno() {
    if (this.isstatus === 'newCustomer') {
      this.getAccountNo = '';
      this.getIFSCNo = this.userdata.stringval9;
      let accountNo = this.userdata.stringval8;
      if (this.getIFSCNo && accountNo) {
        for (let i = 0; i < accountNo.length; i++) {
          if (i <= 1 || i > accountNo.length - 3) {
            this.getAccountNo += accountNo[i];
          } else {
            this.getAccountNo += 'X';
          }
        }
      }
    }
  }

  submitexistingCustomerData(template: any, template1: any) {
    let temp = template;
    if (this.isValidAppno || this.isValidAge) {
      this.toster.error('Please fill the required fields!');
      return;
    }
    this.isError = false;
    this.localStorageService.set('Status', this.isstatus);
    if (this.dataProvided.dateOfBirth) {
      // const date2 = formatDate(this.userDataexistingCustomer.dateOfBirth, this.bsConfig1.dateInputFormat, this.locale);
      const date2 = moment(this.dataProvided.dateOfBirth, 'DD-MM-YYYY').format(
        'DD/MM/YYYY'
      );
      // const date2 = moment(this.userDataexistingCustomer.dateOfBirth).format('DD/MM/YYYY');
      this.finalDate = date2;
    }
    this.spinner.show();
    let url = Constant.BaseUrl + Constant.setExistingCustomerData;

    let reqObj = {
      p_application_no: this.dataProvided.applicationOrPolicyno,
      p_dob: this.finalDate,
      p_prem_amount: '',
      p_frequency_value: '',
      p_module: 'OPEN_LINK_EXISTING',
      p_is_unique_code: 'NO',
    };
    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        if (response.p_error_code === 'SUCCESS') {
          //this.localStorageService.set("FLAGFOREXISTING", response.p_data.stringval11);
          this.nriFLAG = response.p_data.stringval11;
          this.localStorageService.set(
            'setPSFFlag',
            response.p_data.stringval12
          );
          this.localStorageService.set(
            'setGBOFlag',
            response.p_data.stringval13
          );
          this.newAgentCode =  response.p_data.stringval20
          this.channelDetails(this.newAgentCode,this.mandateTokenValue);
          // this.displayNum = this.dataProvided.applicationOrPolicyno;
          this.getAllData(template, template1);
          // this.spinner.hide();
        } else {
          this.errorMessage = response.p_message;
          this.modalRef = this.modalService.show(template, {
            class: 'modal-lg addcompmodal',
          });
          this.dataProvided.applicationOrPolicyno = '';
          this.dataProvided.dateOfBirth = '';
          this.spinner.hide();
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  getAllData(template: any, template1: any) {
    // for whatsup user
    // this.spinner.show();
    let url = Constant.BaseUrl + Constant.getAllData;
    let reqObj = {
      policy_no: this.dataProvided.applicationOrPolicyno,
      dob: this.finalDate,
      mobile_no: '',
      email_id: '',
      request_source: 'AUTO_PAY',
      is_insured: 'Y',
    };

    this.service.PostService(url, reqObj).subscribe((response: any) => {

      let data = [];
      if (response.status === 'success' || response.Status === 'SUCCESS') {
        data = response.payment_details_list;
        if (data) {

          this.userdata = response.payment_details_list;

           //PD-1839 - if multiple policies are present for existing customer then filter based on policy no
            if (response.payment_details_list.length > 1) {
              this.userdata = response.payment_details_list.filter(
                (item: any) => item.policy_no === reqObj.policy_no
              );
            }

          /* start Added by aishwarya on 04-11-2020*/
          /// this.localStorageService.set("userdata", response.payment_details_list);
          this.localStorageService.set('customerportal', this.paymentType);

            //this.router.navigate(['/Customer']);

            // this.spinner.hide();

            if (this.userdata[0].is_opus_policy == 'N') {
              this.isPolicy = 'NGIN';
            }

            this.getPaymentData();
            this.showAccodian2 = true;
            this.showAccodian3 = true;
            this.collapseTwo.nativeElement.classList.add('show');
            this.collapseThree.nativeElement.classList.add('show');

            if (this.closeaccordian1) {
              this.closeaccordian1.nativeElement.click();
            }
          } else {
            this.spinner.hide();
            this.toster.error('No Data Available');
          }
        } else {
          console.log('error');

          this.isError = true;
          // this.showNewForm = false;
          // this.showOldForm = false;
          this.errorMessage = response.errorMsg;
          this.toster.error(this.errorMessage);
          this.spinner.hide();
        }
      },
      (error) => {
        this.errorMessage =
          'Oops! Something went wrong. Please try again later.';
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    );
  }

  proceedToNgin(
    event: any,
    dob: any,
    template: any,
    template2: any,
    template3: any
  ) {
    console.log('Proceeding to NGIN');
    this.spinner.show();
    let url = Constant.BaseUrl + Constant.getApplicationTracker;
    let reqObj = {
      request_source: 'MR',
      application_no: this.appl,
      proposal_no: '',
      ouote_no: '',
      mobile_no: '',
      business_code: '',
      user_type: '',
      tracker_obj: {
        domain_id: '',
        ip_address: '',
      },
    };

    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.Status == 'Failure') {
          //this.modalRef1 = this.modalService.show(template3, { class: 'modal-md addcompmodal' });
          this.spinner.hide();
          this.errorMessage = response.errorMsg;
          this.toster.error(this.errorMessage);
          this.userDatanewCustomer.premiumAmount = '';
          this.newdate2 = '';
          this.userDatanewCustomer.frequency = '';
        }
        if (
          response.status == 'success' ||
          response.status == 'Success' ||
          response.status == 'SUCCESS' ||
          response.status_code == '200'
        ) {
          if (
            (response.tracker_out_obj &&
              response.tracker_out_obj.premium == '') ||
            response.tracker_out_obj.dob == '' ||
            response.tracker_out_obj.booking_frequency == ''
          ) {
            this.modalRef1 = this.modalService.show(template3, {
              class: 'modal-md addcompmodal',
            });

            this.errorMessage = 'Please enter valid application number.';
            this.toster.error(this.errorMessage);
            this.spinner.hide();

            this.premium = '';
            this.newdate2 = '';
            this.frequencyShow = '';
          }
          if (response.tracker_out_obj != '') {
            // this.showPolicyO = false;
            //  this.showPolicyN = true;
            if (response.tracker_out_obj.premium != '') {
              this.premium = response.tracker_out_obj.premium;
              // this.showAmtO = false;
              // this.showAmtN = true;
            }
            if (response.tracker_out_obj.dob != '') {
              this.date = response.tracker_out_obj.dob;
              this.newdate2 = moment(this.date).format('DD-MM-YYYY');
              // this.newdate2 = formatDate(this.date, this.bsConfig.dateInputFormat, this.locale);
              // this.showDateO = false;
              //       this.showDateN = true;
            }
            if (response.tracker_out_obj.booking_frequency != '') {
              this.freq = response.tracker_out_obj.booking_frequency;
              // this.showFreO = false;
              //   this.showFreN = true;
            }

            if (
              this.freq == 'Annual' ||
              this.freq == 'Yearly' ||
              this.freq == 'ANNUAL' ||
              this.freq == 'annual'
            ) {
              this.frequencyShow = 'Yearly';
            } else if (this.freq == 'Monthly' || this.freq == 'MONTHLY') {
              this.frequencyShow = 'Monthly';
            } else if (this.freq == 'Quarterly' || this.freq == 'QUARTERLY') {
              this.frequencyShow = 'Quarterly';
            } else if (
              this.freq == 'Half-Yearly' ||
              this.freq == 'SEMI_ANNUAL' ||
              this.freq == 'Semi-Annual'
            ) {
              this.frequencyShow = 'Half-Yearly';
            }

            ///added for DOB Validation starts
            const apiDate = moment(
              this.dataProvided.dateOfBirth,
              'MM-DD-YYYY'
            ).format('DD-MM-YYYY');
            //const apiDate2 = moment(this.newdate2, 'MM-DD-YYYY').format('DD-MM-YYYY');
            const apiDate2 = this.newdate2;

            if (apiDate2 === apiDate) {
              console.log('Valid Date');
            } else {
              console.log('Non Valid Date');
              this.dataProvided.dateOfBirth = '';
              this.errorMessage = 'Invalid DOB.';
              this.toster.error(this.errorMessage);
              return;
            }
            ///added for DOB Validation ends

            this.userDatanewCustomer = {
              applicationNo: this.appl,
              dateOfBirth: this.newdate2,
              premiumAmount: this.premium,
              frequency: this.frequencyShow,
            };

            if (
              this.userDatanewCustomer.applicationNo != '' &&
              this.userDatanewCustomer.dateOfBirth != '' &&
              this.userDatanewCustomer.premiumAmount != '' &&
              this.userDatanewCustomer.frequency != ''
            ) {
              this.submitNewCustomerData(template);
            }
          }
        } else {
          // this.showPolicyO = true;
          // this.showPolicyN = false;
        }
      },
      (error: any) => {
        this.errorMessage =
          'Oops! Something went wrong. Please try again later.';
        this.toster.error(this.errorMessage);
        this.spinner.hide();
      }
    );
  }

  getPaymentData() {
    // debugger
    this.spinner.show();

    this.checkWarningMsg();
    this.checkForVendor();
    this.checkForUPIVendor();
    this.checkForCCSIVendor();
    this.setLogs(this.displayNum);

    this.frequency = '';
    this.duedate = '';
    this.showEnach = true;
    this.selectedRadioOption = 'no';
    this.isChecked = false;

    this.paymentType = this.localStorageService.get('customerportal');
    this.isChannel = this.localStorageService.get('channel');
    //this.isApplnChannel = this.localStorageService.get('applnChannel');
    //this.agentCode = this.localStorageService.get('agentCode');

    if (this.localStorageService.get('moduleFlag')) {
      if (
        this.localStorageService.get('moduleFlag') == 'IPPBBC' ||
        this.localStorageService.get('moduleFlag') == 'IPPB' ||
        this.localStorageService.get('moduleFlag') == 'IPPBC'
      ) {
        this.moduleFlag = true;
      }
    }

    this.maskifyACno();

    if (
      this.paymentType !== null &&
      this.paymentType !== 'null' &&
      this.paymentType !== '' &&
      this.paymentType !== 'undefined'
    ) {
      if (this.paymentType.toLowerCase() == 'all') {
        this.showEnachPan = true;
        this.showEmandatePan = true;
        //this.showUPIPan = true;
      } else if (this.paymentType.toLowerCase() == 'ccsi') {
      } else if (
        this.paymentType.toLowerCase() == 'nach' ||
        this.paymentType.toLowerCase() == 'enach'
      ) {
        this.showEnachPan = true;
      } else if (
        this.paymentType.toLowerCase() == 'mandate' ||
        this.paymentType.toLowerCase() == 'emand'
      ) {
        this.showEmandatePan = true;
      } else if (this.paymentType.toLowerCase() == 'upi') {
        this.showUPIPan = true;
      } else {
        alert("You have opted wrong module. you can't proceed further");
      }
    } else {
      // this.showCCSIPan = true;
      //  this.showUPIPan = true;
      this.showEnachPan = true;
      this.showEmandatePan = true;
    }

    if (this.isPolicy == 'NGIN') {
      this.emandate = Constant.BaseUrl + Constant.emandate_NGIN;
      this.enach = Constant.BaseUrl + Constant.enach_NGIN;
      this.upiManUrl = Constant.BaseUrl + Constant.upiMandate_NGIN;
    } else {
      this.emandate = Constant.BaseUrl + Constant.emandate;
      this.enach = Constant.BaseUrl + Constant.enach;
      this.upiManUrl = Constant.BaseUrl + Constant.upiMandate;
    }

    this.ccsi = Constant.ccsi;
    this.userDateDetails.dateType = 'SAME';
    this.userDateDetails.isDisabled = 'false';

    if (this.isstatus === 'newCustomer') {
      if (this.originalPremiumAmt > 10000000) {
        this.showEnach = false;
      } else {
        this.showEnach = true;
      }
      //calculate mandate value for UPI (upi dosen't have 125% premium functionality that's why calculated seprate premium)
      //this.mandateAmountNewCustomer= (this.originalPremiumAmt * 1.5).toFixed(2)

      // if (this.isApplnChannel == 'psf_defence' || this.isApplnChannel == 'PSF_DEFENCE') {
      //   this.mandateAmountNewCustomer = this.userdata.stringval5;
      // } else {
      //   this.mandateAmountNewCustomer = (this.originalPremiumAmt * 1.50).toFixed(2) //ops-19382
      // }

      //this.mandateValueForUpi = (this.originalPremiumAmt * 1.1).toFixed(2)
      this.activateUPI = false;
      // upi enable for instab

      if (this.isChannel == 'agency' && this.userdata.stringval5 < 15000) {
        this.showUPIPan = true;
      }

      // upi enabled for new cust
      if (this.userdata.stringval5 < 15000) {
        if (this.isApplnChannel == 'agency' || this.isApplnChannel == 'psf') {
          this.showUPIPan = true;
          this.activateUPIForNB = true;
        }
      }

      if (this.agentCode == '3000000007' && this.userdata.stringval5 < 15000) {
        this.showUPIPan = true;
        this.activateUPIForNB = true;
      }

      if (
        this.localStorageService.get('moduleFlag') == 'GBOWEB' &&
        this.userdata.stringval5 < 100000
      ) {
        this.showUPIPan = true;
        this.activateUPIForNB = true;
      }

      if (
        (this.userdata.stringval8 && this.userdata.stringval9) ||
        (this.userdata.stringval8 != '' && this.userdata.stringval9 != '')
      ) {
        this.showPrefillOption = true;
      }

      const newNRIFLAG = this.nriFLAG;
      if (newNRIFLAG == 'NRI' || newNRIFLAG == 'FOREIGN NATIONAL') {
        this.showCCSINRI = true;
      }

      let url = Constant.validateUPIAgent;
      let reqObj = {
        agentCode: this.agentCode,
        sysType: 'UPI_CONFIG',
      };
      this.service.PostService(url, reqObj).subscribe((response: any) => {
        if (
          response.isAuthenticated === 'Y' &&
          this.userdata.stringval5 < 15000
        ) {
          this.showUPIPan = true;
          this.activateUPIForNB = true;
        }
      });

      //PGCL NGIN implementation
      // if (this.isPolicy == 'NGIN') {
      //   this.showUPIPan = false;
      //   this.showCCSIPan = false;
      //   this.showCCSINRI = false;
      // }

      if (this.userdata.stringval5 > 15000) {
        this.showCCSIPan = false;
        this.showCCSINRI = false;
      }

      this.spinner.hide();
    } else if (this.isstatus === 'existingCustomer') {
      this.frequency = this.userdata[0].frequency;
      this.duedate = this.userdata[0].from_due_date
        ? this.userdata[0].from_due_date
        : this.userdata[0].start_date;
      //console.log("this.duedate", this.duedate)
      if (this.userdata[0].premium_installment > 10000000) {
        this.showEnach = false;
        if (
          this.paymentType.toLowerCase() == 'nach' ||
          this.paymentType.toLowerCase() == 'enach'
        ) {
          this.showEnachPan = false;
          alert(
            'Mandate amount limit exceeded. Please use alternative Autopayment mode'
          );
        }
      } else {
        this.showEnach = true;
      }
      /*--validation for 5k amount for UPI Mandate added on 17-11-2022 by mantis bug-(7800) akash--*/
      //  if((parseInt(this.userdata[0].premium_installment) + parseInt(this.userdata[0].gst_st)) > 15000 || parseInt(this.userdata[0].premium_installment) > 15000) {

      //added for ngin config issue AP-1834
      var prmAmt = this.userdata[0].mandate_amount
        ? this.userdata[0].mandate_amount
        : 'NODATA';
      if (
        (prmAmt != '' || prmAmt != null || prmAmt != '0' || prmAmt != 0) &&
        prmAmt != 'NODATA'
      ) {
        this.userdata[0].premium_installment = prmAmt;
        this.userdata[0].gst_st = 0;
      }

      this.premiumWithGST = (
        parseFloat(this.userdata[0].premium_installment) +
        parseFloat(this.userdata[0].gst_st)
      ).toFixed(2);

      //setPSFFlag
      var freq;
      if (
        this.userdata[0].frequency == 'Half-Yearly' ||
        this.userdata[0].frequency == 'SEMI_ANNUAL' ||
        this.userdata[0].frequency == 'Semi-Annual'
      ) {
        freq = 2;
      } else if (
        this.userdata[0].frequency == 'Monthly' ||
        this.userdata[0].frequency == 'MONTHLY'
      ) {
        freq = 12;
      } else if (
        this.userdata[0].frequency == 'Quartearly' ||
        this.userdata[0].frequency == 'QUARTERLY' ||
        this.userdata[0].frequency == 'Quartearly' ||
        this.userdata[0].frequency == 'QUARTEARLY'
      ) {
        freq = 4;
      } else {
        freq = 1;
      }

      if (this.localStorageService.get('setPSFFlag') == 'PSF_DEFENCE') {
        if (freq == 12) {
          this.userdata[0].final_amount = (this.premiumWithGST * 6).toFixed(2);
        } else {
          this.userdata[0].final_amount = (
            this.premiumWithGST *
            freq *
            1.3
          ).toFixed(2);
        }
      } else {
        if (freq == 12 && this.channel == 'PSF') {
          this.userdata[0].final_amount = (this.premiumWithGST * 6).toFixed(2);
        } else if(this.channel == 'PSF' && freq != 12) {
          this.userdata[0].final_amount = (
            this.premiumWithGST *
            1.3 * freq
          ).toFixed(2);
        }
        else{
          this.userdata[0].final_amount = (this.premiumWithGST * 1.3).toFixed(2);
        }
      }

      // if (parseInt(this.userdata[0].premium_installment) > 15000 || parseInt(this.userdata[0].final_amount) > 15000) {
      //   this.showUPIPan = false;
      // } else {
      //   this.showUPIPan = true;
      // }

      // if ( parseInt(this.userdata[0].final_amount) > 15000) {
      //   this.showUPIPan = false;
      // } else {
      //   this.showUPIPan = true;
      // }

      // if (parseInt(this.userdata[0].final_amount) < 15000) {
      //   this.showUPIPan = true;
      // } else if (parseInt(this.userdata[0].final_amount) < 100000 && this.localStorageService.get('setGBOFlag') == 'GBOWEB') {
      //   this.showUPIPan = true;
      // } else {
      //   this.showUPIPan = false;
      // }
      
       if (parseInt(this.userdata[0].final_amount) < 100000) {
        this.showUPIPan = true;
      }else {
        this.showUPIPan = false;
      }


      if (this.userdata[0].moduleName == 'GROUP_ID') {
        this.subModule = 'GROUP_ID';
      } else if (this.userdata[0].moduleName == 'frequency_change') {
        this.subModule = 'frequency_change';
      }

      // debugger
      //ccsi enabled for 15k on 22-11-23
      // if (this.userdata[0].final_amount > 15000) {
      //   this.showCCSIPan = false;
      //   //  this.showCCSIPan = false;
      // } else {
      //   this.showCCSIPan = true;
      // }
      this.showCCSIPan = true;
      const nriFlag = this.nriFLAG;
      if (nriFlag == 'NRI' || nriFlag == 'FOREIGN NATIONAL') {
        this.showCCSINRI = true;
      }

      //OPS-16142 blocking for Agency SISO product starts
      if (
        this.userdata[0].policy_no[0] != '1' &&
        this.userdata[0].policy_no.length == 10
      ) {
        let url1 = Constant.validateSISOExtisting;
        let reqObj1 = {
          policyNo: this.userdata[0].policy_no,
        };
        this.service.PostService(url1, reqObj1).subscribe((response: any) => {
          if (response.policyChanel === 'AGENCY') {
            this.showUPIPan = false;
          }
        });
      }
      //OPS-16142 blocking for Agency SISO product ends

      //PGCL NGIN implementation
      // if (this.isPolicy == 'NGIN' || !(this.userdata[0].policy_no[0] != '1' && this.userdata[0].policy_no.length == 10)) {
      //   this.showUPIPan = false;
      //   this.showCCSIPan = false;
      //   this.showCCSINRI = false;
      // }

      this.getValue(0);
      this.spinner.hide();
    }
    this.spinner.hide();
  }

  getValue(no: any) {
    console.log('inside getting preferdate');
    let i = 1,
      j = 0;
    this.preferedDateList = [];
    this.userDateDetails.selectedPDate = '';
    let day = this.duedate.split('/')[0];
    console.log('this.duedate is', this.duedate);
    if (day) {
      if (
        this.frequency == 'Monthly' ||
        this.frequency == '12' ||
        this.userdata[0].frequency == 'MONTHLY'
      ) {
        j = parseInt(day) + 10;
        if (j > 28) {
          j = 28;
        }
        for (i = 1; i <= j; i++) {
          let temp = { month: i };
          this.preferedDateList.push(temp);
        }
      } else if (
        (this.frequency == 'Quarterly' ||
          this.frequency == '3' ||
          this.frequency == 'Quartearly' ||
          this.frequency == '3' ||
          this.frequency == 'Half-Yearly' ||
          this.frequency == '2' ||
          this.frequency == 'Yearly' ||
          this.frequency == '1' ||
          this.frequency == 'YEARLY' ||
          this.frequency == '1' ||
          this.frequency == 'QUARTERLY' ||
          this.frequency == '3' ||
          this.frequency == 'QUARTEARLY' ||
          this.frequency == '3' ||
          this.frequency == 'Semi-Annual' ||
          this.frequency == '2' ||
          this.frequency == 'SEMI_ANNUAL' ||
          this.frequency == '2' ||
          this.frequency == 'ANNUAL' ||
          this.frequency == '1' ||
          this.frequency == 'semi annual' ||
          this.frequency == '2') &&
        no == '0'
      ) {
        j = 28;
        for (i = 1; i <= j; i++) {
          let temp = { month: i };
          this.preferedDateList.push(temp);
        }
      } else if (
        (this.frequency == 'Quarterly' ||
          this.frequency == '3' ||
          this.frequency == 'Quartearly' ||
          this.frequency == '3' ||
          this.frequency == 'Half-Yearly' ||
          this.frequency == '2' ||
          this.frequency == 'Yearly' ||
          this.frequency == '1' ||
          this.frequency == 'YEARLY' ||
          this.frequency == '1' ||
          this.frequency == 'QUARTERLY' ||
          this.frequency == '3' ||
          this.frequency == 'QUARTEARLY' ||
          this.frequency == '3' ||
          this.frequency == 'Semi-Annual' ||
          this.frequency == '2' ||
          this.frequency == 'SEMI_ANNUAL' ||
          this.frequency == '2' ||
          this.frequency == 'ANNUAL' ||
          this.frequency == '1' ||
          this.frequency == 'semi annual' ||
          this.frequency == '2') &&
        no == '1'
      ) {
        if (day >= '11' && day <= '31') {
          j = parseInt(day) - 10;
          for (i = 1; i <= j; i++) {
            let temp = { month: i };
            this.preferedDateList.push(temp);
          }
        } else {
          this.userDateDetails.selectedPDate = '';
        }
      }
    }
  }
  loadJs() {
    var acc = document.getElementsByClassName('accordion');
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        //this.classList.toggle("active");
        // var panel = this.nextElementSibling;
        // if (panel.style.maxHeight) {
        //   panel.style.maxHeight = null;
        // } else {
        //   panel.style.maxHeight = panel.scrollHeight + "px";
        // }
      });
    }
  }

  setLogs(consumerID: any) {
   
  const source = this.activatedRoute.snapshot.queryParams['SOURCE'];
  const moduleFinal = (source && source.toUpperCase() === 'BITLY')
    ? 'AUTOMANDATE_BITLY'
    : 'AUTOMANDATE_REG';

    let url = Constant.storeLogs;
    let reqObj =
    {
      module: moduleFinal,
      consumer_id: consumerID
    }
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log('LOG Response :: ' + response.status);
    });
  }

  checkWarningMsg() {
    let url = Constant.downTimeUrl;
    this.http
      .get(url)
      .pipe(map((res: any) => res.json()))
      .subscribe((res: any) => {
        if (res) {
          this.downTimeData = res;
          // this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
          this.downTimeData.forEach((element: any) => {
            if (element.downtime_TYPE.toLowerCase() == 'alert') {
              this.desableForDwontime = true;
            } else if (element.downtime_TYPE.toLowerCase() == 'warning') {
            }
          });
        }
      });
  }

  // checkForVendor() {
  //   //RAZORPAY,
  //   //TECHPROCESS, basis on that values it will enable and desabled
  //   this.enableForVendor = "TECHPROCESS";
  //   let url = Constant.vendorType
  //   this.http.get(url).pipe(map((res: any) => res.json())).subscribe((res: any) => {
  //     if (res) {
  //     }
  //   })
  // }

  checkForVendor() {
    //RAZORPAY,
    //TECHPROCESS, basis on that values it will enable and desabled
    // this.enableForVendor = "TECHPROCESS";
    let url = Constant.vendorTypeNACH;
    this.http
      .get(url)
      .pipe(map((res: any) => res.json()))
      .subscribe((res) => {
        if (res) {
          // if (this.isstatus == "newCustomer" && this.userdata.stringval1.length < 10) {
          // if ((this.isstatus === 'newCustomer' && this.isPolicy == 'NGIN') ||
          //   (this.isstatus === 'newCustomer' && this.userdata.stringval1.length < 10) ||
          //   (this.isstatus === 'existingCustomer' && this.userdata[0].policy_no[0] == '1' && this.userdata[0].policy_no.length > 10)
          //   || (this.isstatus === 'existingCustomer' && this.userdata[0].is_opus_policy == 'N')) {
          //   this.enableForVendor = "TECHPROCESS";
          // } else {
          //   this.enableForVendor = res[0].char_VALUE;
          // }
          //this.enableForVendor = "PAYGLOCAL";
          // this.enableForVendor = res[0].char_VALUE;

          // if (
          //   this.isstatus == 'newCustomer' &&
          //   this.userdata.stringval1.length < 10
          // ) {
          //   this.enableForVendor = 'TECHPROCESS';
          // } else {
          //   this.enableForVendor = res[0].char_VALUE;
          // }
          this.enableForVendor = res[0].char_VALUE;
        }
      });
  }

  checkForUPIVendor() {
    //RAZORPAY,
    //TECHPROCESS,
    // this.enableForUPIVendor = "RAZORPAY";
    let url = Constant.vendorTypeUPI;
    this.http
      .get(url)
      .pipe(map((res: any) => res.json()))
      .subscribe((res) => {
        if (res) {
          //  if (this.isstatus == "newCustomer" && this.userdata.stringval1.length < 10) {
          // if ((this.isstatus === 'newCustomer' && this.isPolicy == 'NGIN') ||
          //   (this.isstatus === 'newCustomer' && this.userdata.stringval1.length < 10) ||
          //   (this.isstatus === 'existingCustomer' && this.userdata[0].policy_no[0] == '1' && this.userdata[0].policy_no.length > 10)
          //   || (this.isstatus === 'existingCustomer' && this.userdata[0].is_opus_policy == 'N')) {
          //   this.enableForUPIVendor = "TECHPROCESS";
          // } else {
          //   this.enableForUPIVendor = res[0].char_VALUE;
          // }
          //  this.enableForUPIVendor = "PAYGLOCAL";
          this.enableForUPIVendor = res[0].char_VALUE;
          // this.enableForUPIVendor = "RAZORPAY";
          // this.enableForUPIVendor = "TECHPROCESS";
        }
      });
  }

  checkForCCSIVendor() {
    //RAZORPAY,
    //TECHPROCESS,
    // this.enableForUPIVendor = "RAZORPAY";
    let url = Constant.vendorTypeCCSI;
    this.http
      .get(url)
      .pipe(map((res: any) => res.json()))
      .subscribe((res) => {
        if (res) {
          //    if (this.isstatus == "newCustomer" && this.userdata.stringval1.length < 10) {
          // if ((this.isstatus === 'newCustomer' && this.isPolicy == 'NGIN') ||
          //   (this.isstatus === 'newCustomer' && this.userdata.stringval1.length < 10) ||
          //   (this.isstatus === 'existingCustomer' && this.userdata[0].policy_no[0] == '1' && this.userdata[0].policy_no.length > 10)
          //   || (this.isstatus === 'existingCustomer' && this.userdata[0].is_opus_policy == 'N')) {
          //   this.enableForCCSIVendor = "HDFCCCSI";
          // } else {
          //   this.enableForCCSIVendor = res[0].char_VALUE;
          // }
          //this.enableForCCSIVendor = "PAYGLOCAL";
          this.enableForCCSIVendor = res[0].char_VALUE;
          // this.enableForCCSIVendor = "HDFCCCSI";
        }
      });
  }

  payWithRozarPay() {
    let data;
    let merchantID = Constant.RAZORPAY_KEY;
    if (this.isstatus === 'newCustomer') {
      data = {
        policyHolderName: '',
        totalAmount: 0,
        merchantId: merchantID,
        consumerId: this.userdata.stringval1,
        consumerMobileNo: '',
        consumerEmailId: '',
        debitStartDate: this.userdata.stringval3,
        debitEndDate: this.userdata.stringval4,
        maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
        amountType: 'M',
        frequency: 'ADHO',
        moduleName: 'INSTAB|OPEN_LINK_NEW',
        renewalID: 'OPEN_LINK_NEW',
        payableAmount: 0,
        takeAccountNo: this.userdata.stringval8,
        takeIFSCCode: this.userdata.stringval9,
        prefDate: '',
        prefType: '',
        authType: this.r_registerType,
      };
    } else if (this.isstatus === 'existingCustomer') {
      data = {
        policyHolderName: '',
        totalAmount: 5,
        merchantId: merchantID,
        consumerId: this.userdata[0].stringval1,
        consumerMobileNo: this.userdata[0].stringval34,
        consumerEmailId: this.userdata[0].stringval35,
        debitStartDate: this.userdata[0].stringval32,
        debitEndDate: this.userdata[0].stringval33,
        maxAmount: parseFloat(this.userdata[0].stringval31).toFixed(),
        amountType: 'M',
        frequency: 'ADHO',
        moduleName: 'OPEN_LINK_EXISTING',
        renewalID: 'OPEN_LINK_EXISTING',
        payableAmount: 0,
        takeAccountNo: '',
        takeIFSCCode: '',
        prefDate: this.userDateDetails.selectedPDate,
        prefType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        authType: this.r_registerType,
      };
    } else {
    }

    let url = Constant.createCustomer;
    let reqObj = data;
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log(response);
      if (response && response.oid && response.custRes.id) {
        this.spinner.hide();
        this.callRozarPay(response.oid, response.custRes.id);
      } else {
        this.spinner.hide();
        alert(response.p_message);
      }
    });
  }

  callRozarPay(orderID: any, CustID: any) {
    let merchantID = Constant.RAZORPAY_KEY;
    var options = {
      key: merchantID,
      order_id: orderID,
      customer_id: CustID,
      recurring: '1',
      name: 'Bajaj Life Insurance Limited',
      image: './assets/img/bajaj-logo.png',
      handler: (response: any) => {
        console.log(response);
        if (response) {
          localStorage.setItem('s2sResponse', JSON.stringify(response));
          this.ngZone.run(() => this.router.navigate(['/RazorPayThankyou']));
        }
      },
      notes: {
        'note_key 1': '',
        'note_key 2': '',
      },
      retry: {
        enabled: false,
      },
      hidden: {
        email: true,
        contact: true,
      },
      theme: {
        color: '#3977b7',
      },
    };
    var rzp1 = new this.service.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on('payment.failed', (response: any) => {
      localStorage.setItem('razorpayError', JSON.stringify(response));
      this.ngZone.run(() => this.router.navigate(['/RazorPayFailure']));
    });
  }

  payWithRozarPayforUPI() {
    let data;
    let merchantID = Constant.RAZORPAY_KEY;
    if (this.isstatus === 'newCustomer') {
      data = {
        policyHolderName: '',
        totalAmount: 0,
        merchantId: merchantID,
        consumerId: this.userdata.stringval1,
        consumerMobileNo: '',
        consumerEmailId: '',
        debitStartDate: this.userdata.stringval3,
        debitEndDate: this.userdata.stringval4,
        maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
        amountType: 'M',
        frequency: 'ADHO',
        moduleName: 'INSTAB|OPEN_LINK_NEW',
        renewalID: 'OPEN_LINK_NEW',
        payableAmount: 0,
        takeAccountNo: this.userdata.stringval8,
        takeIFSCCode: this.userdata.stringval9,
        prefDate: '',
        prefType: '',
        authType: this.r_registerType,
        paymode: 'upi',
      };
    } else if (this.isstatus === 'existingCustomer') {
      var maxAmount;
      if (this.userdata[0].final_amount) {
        if (this.userdata[0].final_amount > 5000) {
          // calulated value
          maxAmount = 5000; // calculated value i.e mandate value will be 10 lac
        } else {
          maxAmount = this.userdata[0].final_amount;
        }
      }

      if (this.userdata[0].moduleName == 'GROUP_ID') {
        var debitEndDate = this.userdata[0].end_date;
      } else {
        var debitEndDate = this.userdata[0].mandate_end_date;
      }

      data = {
        policyHolderName: '',
        totalAmount: 0,
        merchantId: merchantID,
        consumerId: this.userdata[0].policy_no,
        consumerMobileNo: this.userdata[0].mobile_no,
        consumerEmailId: this.userdata[0].email_id,
        debitStartDate: this.userdata[0].start_date,
        debitEndDate: debitEndDate,
        maxAmount: parseFloat(maxAmount).toFixed(),
        amountType: 'M',
        frequency: 'ADHO',
        moduleName: 'OPEN_LINK_EXISTING',
        renewalID: this.userdata.sequence_no,
        payableAmount: 0,
        takeAccountNo: '',
        takeIFSCCode: '',
        prefDate: this.userDateDetails.selectedPDate,
        prefType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        authType: this.r_registerType,
        paymode: 'upi',
      };
    } else {
    }

    let url = Constant.createCustomerUPI;
    let reqObj = data;
    this.spinner.show();
    this.service.PostService(url, reqObj).subscribe((response: any) => {
      console.log(response);
      if (response && response.oid && response.custRes.id) {
        this.spinner.hide();
        this.callRozarPayforUPI(response.oid, response.custRes.id);
      } else {
        this.spinner.hide();
        alert(response.p_message);
      }
    });
  }

  callRozarPayforUPI(orderID: any, custID: any) {
    let merchantID = Constant.RAZORPAY_KEY;
    var options = {
      key: merchantID,
      order_id: orderID,
      customer_id: custID,
      recurring: '1',
      name: 'Bajaj Life Insurance Limited',
      image: './assets/img/bajaj-logo.png',
      handler: (response: any) => {
        console.log(response);
        if (response) {
          localStorage.setItem('s2sResponse', JSON.stringify(response));
          this.ngZone.run(() =>
            this.router.navigate(['/RazorPayThankyou'], {
              queryParams: { source: 'RP_UPI' },
            })
          );
        }
      },
      notes: {
        'note_key 1': '',
        'note_key 2': '',
      },
      retry: {
        enabled: false,
      },
      hidden: {
        email: true,
        contact: true,
      },
      theme: {
        color: '#3977b7',
      },
    };
    var rzp1 = new this.service.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on('payment.failed', (response: any) => {
      localStorage.setItem('razorpayError', JSON.stringify(response));
      this.ngZone.run(() =>
        this.router.navigate(['/RazorPayFailure'], {
          queryParams: { source: 'RP_UPI' },
        })
      );
    });
  }

  //implemet international ccsi start

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(
      () => {
        console.log('Text copied to clipboard');
      },
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  }

  //implementation on UPI Paygloccal

  submitinstabFormData(template: any) {
    this.userdata = '';
    this.displayNum = this.uniqueId;
    this.userDatanewCustomer = {
      applicationNo: this.uniqueId,
      dateOfBirth: this.instabFormData.dateIDModal,
      premiumAmount: this.instabFormData.PremiumValueInclusive,
      frequency: this.instabFormData.FrequencyModal,
    };

    if (
      this.userDatanewCustomer.applicationNo != '' &&
      this.userDatanewCustomer.dateOfBirth != '' &&
      this.userDatanewCustomer.premiumAmount != '' &&
      this.userDatanewCustomer.frequency != ''
    ) {
      this.spinner.show();
      this.isstatus = 'newCustomer';
      this.submitNewCustomerDataForInstab(template);
    }
  }

  onProceed() {
    console.log(this.selectedPaymentOption);
    console.log(this.isPolicy);
    console.log(this.isstatus);
    console.log(this.enableForVendor);
    console.log(this.showEnach);
    console.log(this.showEnachPan);
    if (this.selectedPaymentOption === 'internationalcreditCard') {
      this.openCCSINRI();
    } else if (this.selectedPaymentOption === 'domesticcreditCard') {
      if (this.enableForCCSIVendor == 'HDFCCCSI') {
        if (this.isstatus === 'newCustomer') {
          if (this.ccsinewcustbtn) {
            this.ccsinewcustbtn.nativeElement.click();
          }
        } else if (this.isstatus === 'existingCustomer') {
          if (this.ccsiextcustbtn) {
            this.ccsiextcustbtn.nativeElement.click();
          }
        }
      } else if (this.enableForCCSIVendor == 'PAYGLOCAL') {
        this.submitCCSIpgcl();
      }
    } else if (this.selectedPaymentOption === 'debitNetbankingeMandate') {
      if (this.enableForVendor == 'TECHPROCESS') {
        if (this.isPolicy == 'NGIN') {
          if (this.isstatus === 'newCustomer') {
            if (this.netbankemandatenewcust) {
              this.netbankemandatenewcust.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.netbankemandateextcust_ngin) {
              this.netbankemandateextcust_ngin.nativeElement.click();
            }
          }
        } else {
          if (this.isstatus === 'newCustomer') {
            if (this.netbankemandatenewcust) {
              this.netbankemandatenewcust.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.netbankemandateextcust) {
              this.netbankemandateextcust.nativeElement.click();
            }
          }
        }
      } else if (this.enableForVendor == 'PAYGLOCAL') {
        this.submitNACHpgcl();
      }
    } else if (this.selectedPaymentOption === 'debitNetbankingeNach') {
      if (this.enableForVendor == 'TECHPROCESS') {
        if (this.isPolicy == 'NGIN') {
          if (this.isstatus === 'newCustomer') {
            if (this.netbankenachnewcust_ngin) {
              this.netbankenachnewcust_ngin.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.netbankenachextcust_ngin) {
              this.netbankenachextcust_ngin.nativeElement.click();
            }
          }
        } else {
          if (this.isstatus === 'newCustomer') {
            if (this.netbankenachnewcust) {
              this.netbankenachnewcust.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.netbankenachextcust) {
              this.netbankenachextcust.nativeElement.click();
            }
          }
        }
      } else if (this.enableForVendor == 'RAZORPAY') {
        this.payWithRozarPay();
      } else if (this.enableForVendor == 'PAYGLOCAL') {
        this.submitNACHpgcl();
      }
    } else if (this.selectedPaymentOption === 'UPI') {
      if (this.enableForUPIVendor == 'TECHPROCESS') {
        if (this.isPolicy == 'NGIN') {
          if (this.isstatus === 'newCustomer') {
            if (this.upinewcust) {
              this.upinewcust.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.upiextcust_ngin) {
              this.upiextcust_ngin.nativeElement.click();
            }
          } else if (
            this.isstatus === 'newCustomer' &&
            this.isChannel == 'agency' &&
            this.showUPIPan
          ) {
            if (this.upiinstabcust) {
              this.upiinstabcust.nativeElement.click();
            }
          }
        } else {
          if (this.isstatus === 'newCustomer') {
            if (this.upinewcust) {
              this.upinewcust.nativeElement.click();
            }
          } else if (this.isstatus === 'existingCustomer') {
            if (this.upiextcust) {
              this.upiextcust.nativeElement.click();
            }
          } else if (
            this.isstatus === 'newCustomer' &&
            this.isChannel == 'agency' &&
            this.showUPIPan
          ) {
            if (this.upiinstabcust) {
              this.upiinstabcust.nativeElement.click();
            }
          }
        }
      }
      if (this.enableForUPIVendor == 'RAZORPAY') {
        this.payWithRozarPayforUPI();
      }
      if (this.enableForUPIVendor == 'PAYGLOCAL') {
        this.submitUPIPgcl();
      }
    }
  }

  submitNewCustomerDataForInstab(template: any) {
    this.isstatus = 'newCustomer';
    if (this.isValidAppno) {
      this.toster.error('Please fill the required fields!');
      return;
    }
    this.isErrorNewForm = false;
    this.localStorageService.set('Status', this.isstatus);
    // const date1 = formatDate(this.userDatanewCustomer.dateOfBirth, this.bsConfig.dateInputFormat, this.locale);
    // const date1 =  moment(this.userDatanewCustomer.dateOfBirth).format('DD/MM/YYYY');
    const date1 = moment(
      this.userDatanewCustomer.dateOfBirth,
      'DD-MM-YYYY'
    ).format('DD-MM-YYYY');
    this.userDatanewCustomer.dateOfBirth = date1;
    if (this.userDatanewCustomer.frequency.toString() === 'Monthly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (this.userDatanewCustomer.frequency.toString() === 'Quarterly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      ///this.Amount = (this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (
      this.userDatanewCustomer.frequency.toString() === 'Half-Yearly'
    ) {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    } else if (this.userDatanewCustomer.frequency.toString() === 'Yearly') {
      this.Amount = this.userDatanewCustomer.premiumAmount;
      // this.Amount = (this.Amount * 1.1);
      this.Amount = this.Amount * 1.3;
    }

    let url = Constant.BaseUrl + Constant.setNewCustomerData;
    let reqObj = {
      p_unique_id: this.userDatanewCustomer.applicationNo,
      p_application_no: this.userDatanewCustomer.applicationNo,
      p_dob: this.userDatanewCustomer.dateOfBirth,
      p_prem_amount: this.Amount.toFixed(2),
      p_frequency_value: this.userDatanewCustomer.frequency,
      p_module: 'OPEN_LINK_NEW',
      p_is_unique_code: 'YES',
    };
    this.spinner.show();
    console.log('reqobj' + reqObj);
    this.service.PostService(url, reqObj).subscribe(
      (response: any) => {
        if (response.p_error_code === 'SUCCESS') {
          this.spinner.hide();

          this.displayNum = this.userDatanewCustomer.applicationNo;

          this.fromInstab = 'TRUE';
          this.userdata = response.p_data;
          this.originalPremiumAmt = this.userDatanewCustomer.premiumAmount;
          //this.isInstab = false;
          //this.localStorageService.set("isInstab", this.isInstab);
          //this.localStorageService.set("userdata", response.p_data);
          //  this.localStorageService.set("originalpremiumamt", this.userDatanewCustomer.premiumAmount);
          // this.localStorageService.set("mandateVal", this.Amount.toFixed(2));
          this.mandateVal = this.Amount.toFixed(2);

          this.showPrefillOption = false;
          this.isPolicy = 'OPUS';
          this.getPaymentData();
          this.instabmodal.nativeElement.click();
          this.showAccodian2 = true;
          this.showAccodian3 = true;
          this.collapseTwo.nativeElement.classList.add('show');
          this.collapseThree.nativeElement.classList.add('show');
          if (this.closeaccordian1) {
            this.closeaccordian1.nativeElement.click();
          }
          this.showAccodian1 = false;
        } else {
          this.spinner.hide();
          this.modalRef = this.modalService.show(template, {
            class: 'modal-sm addcompmodal',
          });
          this.isErrorNewForm = true;
          this.errorMessage = response.p_message;
          this.userDataexistingCustomer.policyNumber = '';
          this.userDataexistingCustomer.dateOfBirth = '';

          //   this.router.navigate(['/dashboard']);

          this.instabmodal.nativeElement.click();
        }
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  //NGIN Implementation

  //setting data for forms

  sendData() {
    // Mandate for new customer

    if (this.desableForDwontime) {
      //  this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      var totalAmount = '5';
      (<HTMLInputElement>document.getElementById('totalAmount1')).value =
        totalAmount;

      var consumerId = this.userdata.stringval1;
      (<HTMLInputElement>document.getElementById('consumerId1')).value =
        consumerId;

      var consumerMobileNo = '';
      (<HTMLInputElement>document.getElementById('consumerMobileNo1')).value =
        consumerMobileNo;

      var consumerEmailId = '';
      (<HTMLInputElement>document.getElementById('consumerEmailId1')).value =
        consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById('debitStartDate1')).value =
        debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById('debitEndDate1')).value =
        debitEndDate;

      var maxAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById('maxAmount1')).value =
        maxAmount;

      var amountType = 'M';
      (<HTMLInputElement>document.getElementById('amountType1')).value = 'M';

      var frequency = 'ADHO';
      (<HTMLInputElement>document.getElementById('frequency1')).value =
        frequency;

      var renewalID = 'OPEN_LINK_NEW';
      (<HTMLInputElement>document.getElementById('renewalID1')).value =
        renewalID;

      var payableAmount = '0';
      (<HTMLInputElement>document.getElementById('payableAmount1')).value =
        payableAmount;

      // (<HTMLInputElement>document.getElementById("encryptValue1")).value = this.encryptValue;

      if (this.selectedRadioOption === 'yes') {
        var takeAccountNo = this.moduleFlag ? '' : this.userdata.stringval8;
        (<HTMLInputElement>document.getElementById('takeAccountNo1')).value =
          takeAccountNo ? takeAccountNo : '';
        var takeIFSCCode = this.moduleFlag ? '' : this.userdata.stringval9;
        (<HTMLInputElement>document.getElementById('takeIFSCCode1')).value =
          takeIFSCCode ? takeIFSCCode : '';
        var policyHolderName = this.moduleFlag ? '' : this.userdata.stringval7;
        (<HTMLInputElement>document.getElementById('policyHolderName1')).value =
          policyHolderName ? policyHolderName : '';
      } else {
        (<HTMLInputElement>document.getElementById('takeAccountNo1')).value =
          '';
        (<HTMLInputElement>document.getElementById('takeIFSCCode1')).value = '';
        (<HTMLInputElement>document.getElementById('policyHolderName1')).value =
          '';
      }
    }

    // var policyHolderName = "";
    // (<HTMLInputElement>document.getElementById("policyHolderName1")).value = policyHolderName;
  }

  submitDataeme() {
    //Emandate for Existing Customer
    if (this.desableForDwontime) {
      // this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var policyHolderName = element.stringval2;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameexeman')
        )).value = '';

        var totalAmount = '5';
        (<HTMLInputElement>document.getElementById('totalAmountexeman')).value =
          totalAmount;

        var consumerId = element.stringval1;
        (<HTMLInputElement>document.getElementById('consumerIdexeman')).value =
          consumerId;

        var consumerMobileNo = element.stringval34;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNoexeman')
        )).value = consumerMobileNo;

        var consumerEmailId = element.stringval35;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIdexeman')
        )).value = consumerEmailId;

        var debitStartDate = element.stringval32;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateexeman')
        )).value = debitStartDate;

        var debitEndDate = element.stringval33;
        (<HTMLInputElement>(
          document.getElementById('debitEndDateexeman')
        )).value = debitEndDate;

        var maxAmount = element.stringval31;
        (<HTMLInputElement>document.getElementById('maxAmountexeman')).value =
          parseFloat(maxAmount).toFixed(2);

        var amountType = 'M';
        (<HTMLInputElement>document.getElementById('amountTypeexeman')).value =
          amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>document.getElementById('frequencyexeman')).value =
          frequency;

        var renewalID = element.stringval39;
        (<HTMLInputElement>document.getElementById('renewalIDexeman')).value =
          renewalID;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>document.getElementById('moduleIdexeman')).value =
          moduleName;

        var payableAmount = '0';
        (<HTMLInputElement>(
          document.getElementById('payableAmountexeman')
        )).value = payableAmount;

        (<HTMLInputElement>document.getElementById('prefdateeman')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftypeeman')).value = this
          .userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '';
      });
    }
  }

  submitDataeme_NGIN() {
    //Emandate for Existing Customer
    if (this.desableForDwontime) {
      //  this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      //  event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var policyHolderName = element.policy_holder_name;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameexeman')
        )).value = policyHolderName;

        var totalAmount = '5';
        (<HTMLInputElement>document.getElementById('totalAmountexeman')).value =
          totalAmount;

        var consumerId = element.policy_no;
        (<HTMLInputElement>document.getElementById('consumerIdexeman')).value =
          consumerId;

        var consumerMobileNo = element.mobile_no;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNoexeman')
        )).value = consumerMobileNo;

        var consumerEmailId = element.email_id;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIdexeman')
        )).value = consumerEmailId;

        var debitStartDate = element.start_date;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateexeman')
        )).value = debitStartDate;

        // var debitEndDate = element.end_date;
        //var debitEndDate = element.mandate_end_date;

        if (this.userdata[0].moduleName == 'GROUP_ID') {
          var debitEndDate = element.end_date;
        } else {
          var debitEndDate = element.end_date;
        }
        (<HTMLInputElement>(
          document.getElementById('debitEndDateexeman')
        )).value = debitEndDate;

        var maxAmount = element.final_amount;
        (<HTMLInputElement>document.getElementById('maxAmountexeman')).value =
          maxAmount;

        var amountType = 'M';
        (<HTMLInputElement>document.getElementById('amountTypeexeman')).value =
          amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>document.getElementById('frequencyexeman')).value =
          frequency;

        var renewalID = element.sequence_no;
        (<HTMLInputElement>document.getElementById('renewalIDexeman')).value =
          renewalID;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>document.getElementById('moduleIdexeman')).value =
          moduleName;

        var payableAmount = '0';
        (<HTMLInputElement>(
          document.getElementById('payableAmountexeman')
        )).value = payableAmount;

        (<HTMLInputElement>document.getElementById('prefdateeman')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftypeeman')).value = this
          .userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '';

        (<HTMLInputElement>document.getElementById('subModuleeman')).value =
          this.subModule ? this.subModule : '';
      });
    }
  }

  //ENACH Form STARTS

  sendDataForEnachNewCust() { // ENACH FOR NEW CUSTOMER
    if (this.desableForDwontime) {
      //this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      var totalAmount;
      totalAmount = this.userdata.stringval5;

      // var policyHolderName = "";
      // (<HTMLInputElement>document.getElementById("policyHolderNameenach")).value = policyHolderName;

      // var totalAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById('totalAmountenach')).value =
        parseFloat(totalAmount).toFixed(2);

      var consumerId = this.userdata.stringval1;
      (<HTMLInputElement>document.getElementById('consumerIdenach')).value =
        consumerId;

      var consumerMobileNo = '';
      (<HTMLInputElement>(
        document.getElementById('consumerMobileNoenach')
      )).value = consumerMobileNo;

      var consumerEmailId = '';
      (<HTMLInputElement>(
        document.getElementById('consumerEmailIdenach')
      )).value = consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById('debitStartDateenach')).value =
        debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById('debitEndDateenach')).value =
        debitEndDate;

      var maxAmount = '100';
      (<HTMLInputElement>document.getElementById('maxAmountenach')).value =
        maxAmount;

      var amountType = 'M';
      (<HTMLInputElement>document.getElementById('amountTypeenach')).value =
        amountType;

      var frequency = 'ADHO';
      (<HTMLInputElement>document.getElementById('frequencyenach')).value =
        frequency;

      // var moduleName = "INSTAB";
      // (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;

      if (this.selectedRadioOption === 'yes') {
        var takeAccountNo = this.moduleFlag ? '' : this.userdata.stringval8;
        (<HTMLInputElement>(
          document.getElementById('takeAccountNoenatch')
        )).value = takeAccountNo ? takeAccountNo : '';
        var takeIFSCCode = this.moduleFlag ? '' : this.userdata.stringval9;
        (<HTMLInputElement>(
          document.getElementById('takeIFSCCodeenatch')
        )).value = takeIFSCCode ? takeIFSCCode : '';
        var policyHolderName = this.moduleFlag ? '' : this.userdata.stringval7;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameenach')
        )).value = policyHolderName ? policyHolderName : '';
      } else {
        (<HTMLInputElement>(
          document.getElementById('takeAccountNoenatch')
        )).value = '';
        (<HTMLInputElement>(
          document.getElementById('takeIFSCCodeenatch')
        )).value = '';
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameenach')
        )).value = '';
      }
    }
  }

  sendDataForEnachExistingCust() { // ENACH FOR EXISTING CUSTOMER
    if (this.desableForDwontime) {
      ///  this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      //  event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var policyHolderName = element.policy_holder_name;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameenach')
        )).value = policyHolderName;

        var totalAmount = element.final_amount;
        (<HTMLInputElement>document.getElementById('totalAmountenach')).value =
          parseFloat(totalAmount).toFixed(2);

        var consumerId = element.policy_no;
        (<HTMLInputElement>document.getElementById('consumerIdenach')).value =
          consumerId;

        var consumerMobileNo = element.mobile_no;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNoenach')
        )).value = consumerMobileNo;

        var consumerEmailId = element.email_id;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIdenach')
        )).value = consumerEmailId;

        var debitStartDate = element.start_date;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateenach')
        )).value = debitStartDate;

        if (this.userdata[0].moduleName == 'GROUP_ID') {
          var debitEndDate = element.end_date;
        } else {
          var debitEndDate = element.end_date;
        }

        (<HTMLInputElement>document.getElementById('debitEndDateenach')).value =
          debitEndDate;

        var maxAmount = '100';
        (<HTMLInputElement>document.getElementById('maxAmountenach')).value =
          maxAmount;

        var amountType = 'M';
        (<HTMLInputElement>document.getElementById('amountTypeenach')).value =
          amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>document.getElementById('frequencyenach')).value =
          frequency;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>document.getElementById('moduleNameenach')).value =
          moduleName;

        (<HTMLInputElement>document.getElementById('prefdate')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftype')).value = this
          .userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '';
        (<HTMLInputElement>document.getElementById('subModuleenach')).value =
          this.subModule ? this.subModule : '';
      });
    }
  }

  sendDataForEnachNewCust_NGIN() { // ENACH FOR NEW CUSTOMER
    if (this.desableForDwontime) {
      //  this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      //   var totalAmount;
      // if (this.userdata.stringval5 > 10000000) {   // calulated value
      //   totalAmount = 10000000;    // calculated value i.e mandate value will be 10 lac
      // } else {
      //   totalAmount = this.userdata.stringval5;
      // }

      var policyHolderName = '';
      (<HTMLInputElement>(
        document.getElementById('policyHolderNameenach_nb_ngin')
      )).value = policyHolderName;

      var totalAmount = this.userdata.stringval5;
      (<HTMLInputElement>(
        document.getElementById('totalAmountenach_nb_ngin')
      )).value = parseFloat(totalAmount).toFixed(2);

      var consumerId = this.userdata.stringval1;
      (<HTMLInputElement>(
        document.getElementById('consumerIdenach_nb_ngin')
      )).value = consumerId;

      var consumerMobileNo = '';
      (<HTMLInputElement>(
        document.getElementById('consumerMobileNoenach_nb_ngin')
      )).value = consumerMobileNo;

      var consumerEmailId = '';
      (<HTMLInputElement>(
        document.getElementById('consumerEmailIdenach_nb_ngin')
      )).value = consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>(
        document.getElementById('debitStartDateenach_nb_ngin')
      )).value = debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>(
        document.getElementById('debitEndDateenach_nb_ngin')
      )).value = debitEndDate;

      var maxAmount = '100';
      (<HTMLInputElement>(
        document.getElementById('maxAmountenach_nb_ngin')
      )).value = maxAmount;

      var amountType = 'M';
      (<HTMLInputElement>(
        document.getElementById('amountTypeenach_nb_ngin')
      )).value = amountType;

      var frequency = 'ADHO';
      (<HTMLInputElement>(
        document.getElementById('frequencyenach_nb_ngin')
      )).value = frequency;

      // var moduleName = "INSTAB";
      // (<HTMLInputElement>document.getElementById("moduleNameenach")).value = moduleName;
    }
  }

  sendDataForEnachExistingCust_NGIN() { // ENACH FOR EXISTING CUSTOMER
    console.log('form submitted');
    if (this.desableForDwontime) {
      // this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var policyHolderName = element.policy_holder_name;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameenach_ngin')
        )).value = policyHolderName;

        var totalAmount = element.final_amount;
        (<HTMLInputElement>(
          document.getElementById('totalAmountenach_ngin')
        )).value = parseFloat(totalAmount).toFixed(2);

        var consumerId = element.policy_no;
        (<HTMLInputElement>(
          document.getElementById('consumerIdenach_ngin')
        )).value = consumerId;

        var consumerMobileNo = element.mobile_no;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNoenach_ngin')
        )).value = consumerMobileNo;

        var consumerEmailId = element.email_id;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIdenach_ngin')
        )).value = consumerEmailId;

        var debitStartDate = element.start_date;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateenach_ngin')
        )).value = debitStartDate;

        if (this.userdata[0].moduleName == 'GROUP_ID') {
          var debitEndDate = element.end_date;
        } else {
          var debitEndDate = element.end_date;
        }

        (<HTMLInputElement>(
          document.getElementById('debitEndDateenach_ngin')
        )).value = debitEndDate;

        var maxAmount = '100';
        (<HTMLInputElement>(
          document.getElementById('maxAmountenach_ngin')
        )).value = maxAmount;

        var amountType = 'M';
        (<HTMLInputElement>(
          document.getElementById('amountTypeenach_ngin')
        )).value = amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>(
          document.getElementById('frequencyenach_ngin')
        )).value = frequency;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>(
          document.getElementById('moduleNameenach_ngin')
        )).value = moduleName;

        (<HTMLInputElement>document.getElementById('prefdate_ngin')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftype_ngin')).value =
          this.userDateDetails.selectedPDate
            ? this.userDateDetails.dateType
            : '';

        (<HTMLInputElement>(
          document.getElementById('subModuleenach_ngin')
        )).value = this.subModule ? this.subModule : '';
      });
    }
  }

  //ENACH Form ENDS

  //implement internation ccsi end
  sendDataCredit() { // CCSI FOR New Cust
    if (this.userdata) {
      var policyHolderName = '';
      (<HTMLInputElement>document.getElementById('policyHolderccsinew')).value =
        policyHolderName;

      var totalAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById('totalAmountccsinew')).value =
        parseFloat(totalAmount).toFixed();

      var consumerId = this.userdata.stringval1;

      (<HTMLInputElement>document.getElementById('consumerIdccsinew')).value =
        consumerId;

      var consumerMobileNo = '';
      (<HTMLInputElement>(
        document.getElementById('consumerMobileNoccsinew')
      )).value = consumerMobileNo;

      var consumerEmailId = '';
      (<HTMLInputElement>(
        document.getElementById('consumerEmailIdccsinew')
      )).value = consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>(
        document.getElementById('debitStartDateccsinew')
      )).value = debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById('debitEndDateccsinew')).value =
        debitEndDate;

      // <!-- http://10.3.4.21/CustomerPortal/policy/CCSIRegistation.do-->
      //https://payment.baliconline.in/BalicPayment/ccsi/payment_form.jsp
      // (<HTMLInputElement>document.getElementById("return_urlccsinew")).value = this.ccsiReturnUrl;
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  submitDatacreditexsting() { // CCSI for Existing Customer
    this.userdata.forEach((element: any) => {
      var policyHolderName = element.policy_holder_name;
      (<HTMLInputElement>document.getElementById('policyHolderccsiexi')).value =
        policyHolderName;

      var totalAmount = element.final_amount;
      (<HTMLInputElement>document.getElementById('totalAmountccsiexi')).value =
        parseFloat(totalAmount).toFixed();

      var consumerId = element.policy_no;

      (<HTMLInputElement>document.getElementById('consumerIdccsiexi')).value =
        consumerId;

      var consumerMobileNo = element.mobile_no;
      (<HTMLInputElement>(
        document.getElementById('consumerMobileNoccsiexi')
      )).value = consumerMobileNo;

      var consumerEmailId = element.email_id;
      (<HTMLInputElement>(
        document.getElementById('consumerEmailIdccsiexi')
      )).value = consumerEmailId;

      var debitStartDate = element.start_date;
      (<HTMLInputElement>(
        document.getElementById('debitStartDateccsiexi')
      )).value = debitStartDate;

      var debitEndDate = element.end_date;
      (<HTMLInputElement>document.getElementById('debitEndDateccsiexi')).value =
        debitEndDate;
      var frequency = 'ADHO';
      (<HTMLInputElement>document.getElementById('frequencyccsiexi')).value =
        this.ccsiReturnUrl;

      // (<HTMLInputElement>document.getElementById("prefdateccsi")).value = this.userDateDetails.selectedPDate;
      // (<HTMLInputElement>document.getElementById("preftypeccsi")).value = this.userDateDetails.selectedPDate ? this.userDateDetails.dateType: "";
    });
  }

  sendUPIDataNewCust() {
    // UPI Mandate for new customer
    if (this.desableForDwontime) {
      ///  this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      // if ((this.originalPremiumAmont <= 5000) && (this.userdata.stringval5 > 5000)) {   // calulated value
      var policyHolderName = '';
      (<HTMLInputElement>document.getElementById('policyHolderNameu')).value =
        policyHolderName;

      var totalAmount = '0';
      (<HTMLInputElement>document.getElementById('totalAmountu')).value =
        totalAmount;

      var consumerId = this.userdata.stringval1;
      (<HTMLInputElement>document.getElementById('consumerIdu')).value =
        consumerId;

      var consumerMobileNo = '';
      (<HTMLInputElement>document.getElementById('consumerMobileNou')).value =
        consumerMobileNo;

      var consumerEmailId = '';
      (<HTMLInputElement>document.getElementById('consumerEmailIdu')).value =
        consumerEmailId;

      var debitStartDate = this.userdata.stringval3;
      (<HTMLInputElement>document.getElementById('debitStartDateu')).value =
        debitStartDate;

      var debitEndDate = this.userdata.stringval4;
      (<HTMLInputElement>document.getElementById('debitEndDateu')).value =
        debitEndDate;

      // var maxAmount = this.userdata.stringval5;
      (<HTMLInputElement>document.getElementById('maxAmountu')).value =
        this.userdata.stringval5;

      var amountType = 'M';
      (<HTMLInputElement>document.getElementById('amountTypeu')).value = 'M';

      var frequency = 'ADHO';
      (<HTMLInputElement>document.getElementById('frequencyu')).value =
        frequency;

      var renewalID = 'OPEN_LINK_NEW';
      (<HTMLInputElement>document.getElementById('renewalIDu')).value =
        renewalID;

      var payableAmount = '0';
      (<HTMLInputElement>document.getElementById('payableAmountu')).value =
        payableAmount;
    }
  }

  // upi m
  // sendUPIDataInstabCust() {
  //   if (this.desableForDwontime) {
  //     //   this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
  //     //  event.preventDefault();
  //   } else {
  //     if (this.userdata.stringval5 < 15000) {
  //       var policyHolderName = "";
  //       (<HTMLInputElement>document.getElementById("policyHolderNamei")).value = policyHolderName;

  //       var totalAmount = '0';
  //       (<HTMLInputElement>document.getElementById("totalAmounti")).value = totalAmount;

  //       var consumerId = this.userdata.stringval1;
  //       (<HTMLInputElement>document.getElementById("consumerIdi")).value = consumerId;

  //       var consumerMobileNo = "";
  //       (<HTMLInputElement>document.getElementById("consumerMobileNoi")).value = consumerMobileNo;

  //       var consumerEmailId = "";
  //       (<HTMLInputElement>document.getElementById("consumerEmailIdi")).value = consumerEmailId;

  //       var debitStartDate = this.userdata.stringval3;
  //       (<HTMLInputElement>document.getElementById("debitStartDatei")).value = debitStartDate;

  //       var debitEndDate = this.userdata.stringval4;
  //       (<HTMLInputElement>document.getElementById("debitEndDatei")).value = debitEndDate;

  //       var maxAmount = this.userdata.stringval5;
  //       (<HTMLInputElement>document.getElementById("maxAmounti")).value = maxAmount;

  //       var amountType = "M";
  //       (<HTMLInputElement>document.getElementById("amountTypei")).value = 'M'

  //       var frequency = "ADHO";
  //       (<HTMLInputElement>document.getElementById("frequencyi")).value = frequency;

  //       var renewalID = "OPEN_LINK_NEW";
  //       (<HTMLInputElement>document.getElementById("renewalIDi")).value = renewalID;

  //       var payableAmount = '0';
  //       (<HTMLInputElement>document.getElementById("payableAmounti")).value = payableAmount;

  //     }
  //   }

  // }

  sendUPIDataOldCust() {
    //UPI for Existing Customer
    if (this.desableForDwontime) {
      //this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      //  event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var maxAmount;
        // if (element.final_amount) {
        //   if (element.final_amount > 5000) {   // calulated value
        //     maxAmount = 5000;    // calculated value i.e mandate value will be 10 lac
        //   } else {
        //     maxAmount = element.final_amount;
        //   }
        // }

        var policyHolderName = element.policy_holder_name;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameuext')
        )).value = policyHolderName;

        var totalAmount = '0';
        (<HTMLInputElement>document.getElementById('totalAmountuext')).value =
          totalAmount;

        var consumerId = element.policy_no;
        (<HTMLInputElement>document.getElementById('consumerIduext')).value =
          consumerId;

        var consumerMobileNo = element.mobile_no;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNouext')
        )).value = consumerMobileNo;

        var consumerEmailId = element.email_id;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIduext')
        )).value = consumerEmailId;

        var debitStartDate = element.start_date;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateuext')
        )).value = debitStartDate;

        //  var debitEndDate = element.end_date;
        // var debitEndDate = element.mandate_end_date;

        if (this.userdata[0].moduleName == 'GROUP_ID') {
          var debitEndDate = element.end_date;
        } else {
          var debitEndDate = element.mandate_end_date;
        }
        (<HTMLInputElement>document.getElementById('debitEndDateuext')).value =
          debitEndDate;

        var maxAmount = element.final_amount;
        (<HTMLInputElement>document.getElementById('maxAmountuext')).value =
          maxAmount;

        var amountType = 'M';
        (<HTMLInputElement>document.getElementById('amountTypeuext')).value =
          amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>document.getElementById('frequencyuext')).value =
          frequency;

        var renewalID = element.sequence_no;
        (<HTMLInputElement>document.getElementById('renewalIDuext')).value =
          renewalID;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>document.getElementById('moduleIdeuext')).value =
          moduleName;

        var payableAmount = '0';
        (<HTMLInputElement>document.getElementById('payableAmountuext')).value =
          payableAmount;

        (<HTMLInputElement>document.getElementById('prefdateuext')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftypeuext')).value = this
          .userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '';
        (<HTMLInputElement>document.getElementById('subModuleeman')).value =
          this.subModule ? this.subModule : '';
        console.log('prefer date', this.userDateDetails);
      });
    }
  }

  sendUPIDataOldCust_NGIN() {
    //UPI for Existing Customer
    if (this.desableForDwontime) {
      //this.modalRef1 = this.modalService.show(this.templet2, { class: 'modal-md addcompmodal' });
      // event.preventDefault();
    } else {
      this.userdata.forEach((element: any) => {
        var maxAmount;

        var policyHolderName = element.policy_holder_name;
        (<HTMLInputElement>(
          document.getElementById('policyHolderNameuext')
        )).value = policyHolderName;

        var totalAmount = '0';
        (<HTMLInputElement>document.getElementById('totalAmountuext')).value =
          totalAmount;

        var consumerId = element.policy_no;
        (<HTMLInputElement>document.getElementById('consumerIduext')).value =
          consumerId;

        var consumerMobileNo = element.mobile_no;
        (<HTMLInputElement>(
          document.getElementById('consumerMobileNouext')
        )).value = consumerMobileNo;

        var consumerEmailId = element.email_id;
        (<HTMLInputElement>(
          document.getElementById('consumerEmailIduext')
        )).value = consumerEmailId;

        var debitStartDate = element.start_date;
        (<HTMLInputElement>(
          document.getElementById('debitStartDateuext')
        )).value = debitStartDate;

        //  var debitEndDate = element.end_date;
        // var debitEndDate = element.mandate_end_date;

        if (this.userdata[0].moduleName == 'GROUP_ID') {
          var debitEndDate = element.end_date;
        } else {
          var debitEndDate = element.mandate_end_date;
        }
        (<HTMLInputElement>document.getElementById('debitEndDateuext')).value =
          debitEndDate;

        var maxAmount = element.final_amount;
        (<HTMLInputElement>document.getElementById('maxAmountuext')).value =
          maxAmount;

        var amountType = 'M';
        (<HTMLInputElement>document.getElementById('amountTypeuext')).value =
          amountType;

        var frequency = 'ADHO';
        (<HTMLInputElement>document.getElementById('frequencyuext')).value =
          frequency;

        var renewalID = element.sequence_no;
        (<HTMLInputElement>document.getElementById('renewalIDuext')).value =
          renewalID;

        var moduleName = 'OPEN_LINK_EXISTING';
        (<HTMLInputElement>document.getElementById('moduleIdeuext')).value =
          moduleName;

        var payableAmount = '0';
        (<HTMLInputElement>document.getElementById('payableAmountuext')).value =
          payableAmount;

        (<HTMLInputElement>document.getElementById('prefdateuext')).value =
          this.userDateDetails.selectedPDate;
        (<HTMLInputElement>document.getElementById('preftypeuext')).value = this
          .userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '';
        (<HTMLInputElement>document.getElementById('subModuleeman')).value =
          this.subModule ? this.subModule : '';
        console.log('prefer date', this.userDateDetails);
      });
    }
  }

  openCCSINRI() {
    this.spinner.show();
    //this.frequencyforccsiNRI = this.userdata[0].stringval20;
    let generateURL = Constant.NRIccsi;

    var options;
    if (this.isstatus === 'newCustomer') {
      const date1 = this.userdata.stringval3;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
      const date2 = this.userdata.stringval4;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      const formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      options = {
        "merchantTxnId": this.userdata.stringval1,
        "paymentType": "PGCLINTCCSI",
          "surchargeTxn":"true",
        "siAllowedPaymentMethods": ["CARD"],
        "allowedPaymentMethods": [
          {
            paymentMethod: 'CARD',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },
        riskData: {
          customerData: {
            customerCategory: 'FC',
          },
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.NRIccsiCallbackURL,
        moduleName: 'OPEN_LINK_NEW',
        policyHolderName: this.userdata.stringval7,
      };
    } else if (this.isstatus === 'existingCustomer') {
      const date1 = this.userdata[0].start_date;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');

      if (this.userdata[0].moduleName == 'GROUP_ID') {
        var debitEndDate = this.userdata[0].end_date;
      } else {
        var debitEndDate = this.userdata[0].end_date;
      }
      const date2 = debitEndDate;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

      var maxAmount;
      // if (this.userdata[0].final_amount) {
      //   if (this.userdata[0].final_amount > 5000) {   // calulated value
      //     maxAmount = 5000;    // calculated value i.e mandate value will be 10 lac
      //   } else {
      maxAmount = this.userdata[0].final_amount;
      //   }
      // }
      options = {
        "merchantTxnId": this.userdata[0].policy_no,
        "paymentType": "PGCLINTCCSI",
          "surchargeTxn":"true",
        "siAllowedPaymentMethods": ["CARD"],
        "allowedPaymentMethods": [
          {
            paymentMethod: 'CARD',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },
        riskData: {
          customerData: {
            customerCategory: 'FC',
          },
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(maxAmount).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.NRIccsiCallbackURL,
        moduleName: 'OPEN_LINK_EXISTING',
        preferDate: this.userDateDetails.selectedPDate,
        preferType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        policyHolderName: this.userdata[0].policy_holder_name,
      };
    }

    var ss = JSON.stringify(options);
    this.service
      .PostService(generateURL, options)
      .subscribe((response: any) => {
        if (response.status == 'INPROGRESS') {
          this.ccsiPayglocal = response.data.redirectUrl;
          // window.open(this.ccsiPayglocal.toString(), '_blank');
          // this.spinner.hide();

          window.location.href = this.ccsiPayglocal.toString();
        } else {
          this.toster.error('ERROR :: ' + response.status);
          this.spinner.hide();
        }
      });
  }

  submitUPIPgcl() {
    this.spinner.show();
    //this.frequencyforccsiNRI = this.userdata[0].stringval20;
    let generateURL = Constant.NRIccsi;

    var options;
    if (this.isstatus === 'newCustomer') {
      const date1 = this.userdata.stringval3;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
      const date2 = this.userdata.stringval4;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      let formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');
      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

      options = {
        merchantTxnId: this.userdata.stringval1,
        paymentType: 'PGCLUPI',
        siAllowedPaymentMethods: ['UPI_INTENT', 'UPI_COLLECT'],
        allowedPaymentMethods: [
          {
            paymentMethod: 'UPI_INTENT',
          },
          {
            paymentMethod: 'UPI_COLLECT',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },

        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.pgclUPICallbackURL,
        moduleName: 'OPEN_LINK_NEW',
        policyHolderName: this.userdata.stringval7,
      };
    } else if (this.isstatus === 'existingCustomer') {
      const date1 = this.userdata[0].start_date;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');

      if (this.userdata[0].moduleName == 'GROUP_ID') {
        var debitEndDate = this.userdata[0].end_date;
      } else {
        var debitEndDate = this.userdata[0].end_date;
      }
      const date2 = debitEndDate;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

      var maxAmount;
      // if (this.userdata[0].final_amount) {
      //   if (this.userdata[0].final_amount > 5000) {   // calulated value
      //     maxAmount = 5000;    // calculated value i.e mandate value will be 10 lac
      //   } else {
      maxAmount = this.userdata[0].final_amount;
      //   }
      // }

      options = {
        merchantTxnId: this.userdata[0].policy_no,
        paymentType: 'PGCLUPI',
        siAllowedPaymentMethods: ['UPI_INTENT', 'UPI_COLLECT'],
        allowedPaymentMethods: [
          {
            paymentMethod: 'UPI_INTENT',
          },
          {
            paymentMethod: 'UPI_COLLECT',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(maxAmount).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.pgclUPICallbackURL,
        moduleName: 'OPEN_LINK_EXISTING',
        preferDate: this.userDateDetails.selectedPDate,
        preferType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        policyHolderName: this.userdata[0].policy_holder_name,
      };
    }

    var ss = JSON.stringify(options);
    this.service
      .PostService(generateURL, options)
      .subscribe((response: any) => {
        if (response.status == 'INPROGRESS') {
          this.ccsiPayglocal = response.data.redirectUrl;
          // window.open(this.ccsiPayglocal.toString(), '_blank');
          // this.spinner.hide();

          window.location.href = this.ccsiPayglocal.toString();
        } else {
          this.toster.error('ERROR :: ' + response.status);
          this.spinner.hide();
        }
      });
  }

  submitNACHpgcl() {
    this.spinner.show();
    //this.frequencyforccsiNRI = this.userdata[0].stringval20;
    let generateURL = Constant.NRIccsi;

    var options;
    if (this.isstatus === 'newCustomer') {
      const date1 = this.userdata.stringval3;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
      const date2 = this.userdata.stringval4;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      const formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      options = {
        merchantTxnId: this.userdata.stringval1,
        paymentType: 'PGCLNACH',
        allowedPaymentMethods: [
          {
            paymentMethod: 'DIGITAL_BANK_MANDATE',
          },
        ],
        siAllowedPaymentMethods: ['DIGITAL_BANK_MANDATE'],
        paymentData: {
          totalAmount: '1',
          txnCurrency: 'INR',
          bankAccountData: {
            accountHolderName:
              this.selectedRadioOption === 'yes'
                ? this.userdata.stringval7
                : '',
            accountNumber:
              this.selectedRadioOption === 'yes'
                ? this.userdata.stringval8
                : '',
            ifscCode:
              this.selectedRadioOption === 'yes'
                ? this.userdata.stringval9
                : '',
          },
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        moduleName: 'INSTAB|OPEN_LINK_NEW',
        product: {
          productUserName: this.userdata.stringval7,
        },
        merchantCallbackURL: Constant.pgclNACHCallbackURL,
        policyHolderName: this.userdata.stringval7,
      };
    } else if (this.isstatus === 'existingCustomer') {
      const date1 = this.userdata[0].start_date;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      //const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');

      if (this.userdata[0].moduleName == 'GROUP_ID') {
        var debitEndDate = this.userdata[0].end_date;
      } else {
        var debitEndDate = this.userdata[0].end_date;
      }
      const date2 = debitEndDate;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

      options = {
        merchantTxnId: this.userdata[0].policy_no,
        paymentType: 'PGCLNACH',
        allowedPaymentMethods: [
          {
            paymentMethod: 'DIGITAL_BANK_MANDATE',
          },
        ],
        siAllowedPaymentMethods: ['DIGITAL_BANK_MANDATE'],
        paymentData: {
          totalAmount: '1',
          txnCurrency: 'INR',
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata[0].final_amount).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        moduleName: 'OPEN_LINK_EXISTING',
        preferDate: this.userDateDetails.selectedPDate,
        preferType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        product: {
          productUserName: this.userdata[0].policy_holder_name,
        },
        merchantCallbackURL: Constant.pgclNACHCallbackURL,
        policyHolderName: this.userdata[0].policy_holder_name,
      };
    }
    this.service
      .PostService(generateURL, options)
      .subscribe((response: any) => {
        if (
          response.status == 'INPROGRESS' &&
          response.p_next_page != 'error'
        ) {
          this.ccsiPayglocal = response.data.redirectUrl;
          // window.open(this.ccsiPayglocal.toString(), '_blank');
          // this.spinner.hide();

          window.location.href = this.ccsiPayglocal.toString();
        } else if (
          response.status == 'INPROGRESS' &&
          response.p_next_page == 'error'
        ) {
          this.toster.error('ERROR :' + response.p_error_msg);
          this.spinner.hide();
        } else {
          this.toster.error('ERROR :: ' + response.status);
          this.spinner.hide();
        }
      });
  }

  submitCCSIpgcl() {
    this.spinner.show();

    let generateURL = Constant.NRIccsi;

    var options;
    if (this.isstatus === 'newCustomer') {
      const date1 = this.userdata.stringval3;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      // const prtplusoneday = moment(prt).add(1, 'day'); // add 1 day to the date
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');
      const date2 = this.userdata.stringval4;
      const prt1 = moment(date2, 'DD-MM-YYYY').toDate();
      var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }
      options = {
        "merchantTxnId": this.userdata.stringval1,
        "paymentType": "PGCLDOMESTICCCSI",
        "surchargeTxn":"true",
        "siAllowedPaymentMethods": ["CARD"],
        "allowedPaymentMethods": [
          {
            paymentMethod: 'CARD',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata.stringval5).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.pgclCCSICallbackURL,
        moduleName: 'OPEN_LINK_NEW',
        policyHolderName: '',
      };
    } else if (this.isstatus === 'existingCustomer') {
      const date1 = this.userdata[0].start_date;
      const prt = moment(date1, 'DD-MM-YYYY').toDate();
      const formattedDate1 = this.datePipe.transform(prt, 'yyyyMMdd');

      var debitEndDate = this.userdata[0].end_date;
      const prt1 = moment(debitEndDate, 'DD-MM-YYYY').toDate();
      var formattedDate2 = this.datePipe.transform(prt1, 'yyyyMMdd');

      // Calculate the year difference
      const yearDiff =
        moment(formattedDate2, 'YYYYMMDD').year() -
        moment(formattedDate1, 'YYYYMMDD').year();

      if (yearDiff > 40) {
        const maxAllowedDate: any = moment(formattedDate1, 'YYYYMMDD')
          .add(40, 'years')
          .subtract(1, 'day');
        formattedDate2 = this.datePipe.transform(maxAllowedDate, 'yyyyMMdd');
      }

      options = {
        "merchantTxnId": this.userdata[0].policy_no,
        "paymentType": "PGCLDOMESTICCCSI",
        "surchargeTxn":"true",
        "siAllowedPaymentMethods": ["CARD"],
        "allowedPaymentMethods": [
          {
            paymentMethod: 'CARD',
          },
        ],
        paymentData: {
          totalAmount: 1,
          txnCurrency: 'INR',
        },
        standingInstruction: {
          data: {
            maxAmount: parseFloat(this.userdata[0].final_amount).toFixed(),
            numberOfPayments: 'N',
            frequency: 'ONDEMAND',
            type: 'VARIABLE',
            startDate: formattedDate1,
            endDate: formattedDate2,
            mode: 'REGISTER',
          },
        },
        merchantCallbackURL: Constant.pgclCCSICallbackURL,
        moduleName: 'OPEN_LINK_EXISTING',
        preferDate: this.userDateDetails.selectedPDate,
        preferType: this.userDateDetails.selectedPDate
          ? this.userDateDetails.dateType
          : '',
        policyHolderName: this.userdata[0].policy_holder_name,
      };
    }

    this.service
      .PostService(generateURL, options)
      .subscribe((response: any) => {
        if (response.status == 'INPROGRESS') {
          this.ccsiPayglocal = response.data.redirectUrl;
          // window.open(this.ccsiPayglocal.toString(), '_blank');
          // this.spinner.hide();
          window.location.href = this.ccsiPayglocal.toString();
        } else {
          this.toster.error('ERROR :: ' + response.status);
          this.spinner.hide();
        }
      });
  }

    padApplicationOrPolicyNo() {
      if (this.dataProvided && this.dataProvided.applicationOrPolicyno != null) {
        let num = this.dataProvided.applicationOrPolicyno;
        // If input is empty or only whitespace, show error and do not pad
        if (!num || num.trim().length === 0) {
          this.isError = true;
          this.errorMessage = 'Kindly enter valid policy/application no';
          return;
        } else {
          this.isError = false;
          this.errorMessage = '';
        }
        // Always pad to 10 digits if less than 10
        if (num.length < 10) {
          this.dataProvided.applicationOrPolicyno = num.padStart(10, '0');
          num = this.dataProvided.applicationOrPolicyno;
        }
        // If user adds a digit in front (making it 11 digits), allow up to 11 digits
        if (num.length === 10) {
          this.applicationOrPolicynoMaxLength = 11;
        } else if (num.length === 11) {
          this.applicationOrPolicynoMaxLength = 11;
        } else {
          this.applicationOrPolicynoMaxLength = 10;
        }
        // Set validation flags
        if (num.startsWith('1')) {
          this.isValidNGINPolicyno = num.length !== 11 && num.length !== 0;
          this.isValidPolicyno = false;
          this.isValidAppno = false;
        } else {
          this.isValidNGINPolicyno = false;
          this.isValidPolicyno = num.length === 10 ? false : (num.length !== 10 && num.length !== 0);
          this.isValidAppno = num.length === 10 ? false : (num.length !== 10 && num.length !== 0);
        }
      }
    }

}
